import { makeStyles, useTheme, withStyles } from "@material-ui/core/styles";
import { colors } from "../constants/colors";
import { fontSize, fontWeight, lineHeight } from "../constants/typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import welcomeGrainPattern from "../assets/images/Home/wave-pattern-background.png";
import loginBackgroundPng from "../assets/images/login_page_background.png";
import loginBackgroundWebp from "../assets/images/login_page_background.webp";


export const ExpandMore = ExpandMoreIcon;

export const useGlobalStyles = makeStyles((theme) => ({
  lineHeightNormal: {
    lineHeight: "normal",
  },
  clickableLink: {
    cursor: "pointer",
    color: colors.link,
  },
  weighmentHeaderWrapper: {
    display: "flex",
    alignItems: "center",
    gap: 8,
  },
  weighmentHeaderIconCircle: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: 32,
    height: 32,
    borderRadius: "50%",
    backgroundColor: colors.warningBg,
    color: colors.orange,
    flexShrink: 0,
  },
  weighmentHeaderIconSm: { fontSize: "18px !important" },
  weighmentOptionCard: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    padding: "12px 16px",
    borderRadius: 8,
    border: `1px solid ${colors.borderLighter}`,
    marginBottom: 12,
    background: colors.surfaceLight,
  },
  weighmentBadgeYes: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: colors.orange,
    color: colors.white,
    fontWeight: 700,
    fontSize: 12,
    padding: "4px 8px",
    borderRadius: 4,
    flexShrink: 0,
    minWidth: 36,
  },
  weighmentBadgeNo: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "transparent",
    color: colors.orange,
    fontWeight: 700,
    fontSize: 12,
    padding: "4px 8px",
    borderRadius: 4,
    border: `1px solid ${colors.orange}`,
    flexShrink: 0,
    minWidth: 36,
  },
  weighmentCardText: {
    fontSize: 14,
    color: colors.textDark,
  },
  weighmentHighlight: {
    fontWeight: 700,
    color: colors.orange,
  },
  weighmentActions: {
    display: "flex",
    justifyContent: "flex-end",
    gap: 10,
    marginTop: 16,
    paddingTop: 12,
    borderTop: `1px solid ${colors.borderLighter}`,
  },
    addBtnNote: {
    display: "flex",
    alignItems: "center",
    gap: 6,
    color: colors.accentOrange,
    fontSize: 13,
  },
  addBtnNoteIcon: { fontSize: 18 },
  whiteSpacePreWrap: {
   whiteSpace: "pre-wrap"
  },
  mb4: { marginBottom: "4px" },
  mb8: { marginBottom: "8px" },
  mb10: { marginBottom: "10px" },
  mb6: { marginBottom: "6px" },
  mt6: { marginTop: "6px" },
  mt8: { marginTop: "8px" },

  margin10 : {
    margin: "0px 0px 10px 0px !important",
  },

  /* ── Standard list-page root ── */
  listPageRoot: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
  },

  /* ── Filter bar: filters left, buttons right, vertically centred ── */
  filterBar: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    flexWrap: "wrap",
    gap: 8,
    marginBottom: 8,
    minHeight: 40,
    width: "100%",
    "& .MuiFormControl-root": {
      marginTop: "0 !important",
      marginBottom: "0 !important",
    },
  },

  /* ── Left: filter controls ── */
  filterBarLeft: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    flexWrap: "wrap",
    gap: 8,
    flex: "1 1 auto",
    "& .MuiFormControl-root": {
      marginTop: "0 !important",
      marginBottom: "0 !important",
    },
  },

  /* ── Right: action buttons ── */
  filterBarRight: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
    flexShrink: 0,
    marginLeft: "auto",
  },

  mb12: { marginBottom: "12px" },
  confirmModalList: { paddingLeft: 20, marginBottom: 12, margin: 0 },
  confirmModalListItem: { marginBottom: 4 },
  flexWrapStart: {
    width: "100%",
    height: "100%",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "flex-start",
    alignItems: "center",
  },
  centerFlex: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "100px",
  },
  calBlockPartialWarning: {
    display: "flex", alignItems: "flex-start", gap: 8,
    background: colors.warningBg, border: `1px solid ${colors.warningBorder}`, borderRadius: 6,
    padding: "8px 10px", marginBottom: 10, width: "fit-content",
    fontSize: 12, color: colors.warningDarkText, lineHeight: 1.4,
  },
  calBlockPartialWarningIcon: { fontSize: 18, flexShrink: 0, marginTop: -1 },
  cancelModalDescription: { marginBottom: 16 },
  cancelStatCardsRow: { marginBottom: 16 },
  cancelStatCard: {
    padding: "12px 16px",
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 4,
  },
  cancelStatTooltipTrigger: { cursor: "pointer" },
  cancelStatValueRed: { color: colors.errorLight, fontWeight: 700 },
  cancelStatValueGreen: { color: colors.successMid, fontWeight: 700 },
  cancelStatValueOrange: { color: colors.warningMid, fontWeight: 700 },
  cancelWarningBox: {
    background: colors.gridOpacity,
    border: `1px solid ${colors.orange}`,
    borderRadius: 6,
    padding: "12px 16px",
    marginTop: "20px",
  },
  cancelWarningHeader: { marginBottom: 8 },
  cancelWarningIcon: { color: colors.errorLight, marginRight: 8, fontSize: 18 },
  cancelWarningTitle: { color: colors.darkRed, fontWeight: 600 },
  cancelWarningBullet: {
    color: colors.pureBlack,
    display: "flex",
    alignItems: "flex-start",
    marginBottom: 2,
  },
  cancelWarningBulletDot: { marginRight: 6 },
  p10:{padding:'10px'},
  boldlabel: {
    fontSize: `${fontSize.sectionHeading} !important`,  // 14px — from typography tokens
    fontWeight: `${fontWeight.medium} !important`,
  },
  forTableHeaders: {
    whiteSpace: "nowrap",
    fontWeight: `${fontWeight.bold} !important`,
  },
  tabletopmarginright: {
    margin: '10px 47px 10px 20px',
  },
  batchoutputdetailsPagecss: {
    padding:0,
    "& .MuiAccordion-root.Mui-expanded":{
      marginTop:'0 !important',
    }
  },
  dfacjeg: { display: "flex", alignItems: "center", justifyContent: "end", gap:10},
  linkColor: {
    color: colors.link,
  },
  anchor:{
    vertical: "bottom", horizontal: "left"
    },
  transform:{
    vertical: "top", horizontal: "left"
    },
  autocompleteListbox: {
    overflowY: 'auto',
    '& .MuiAutocomplete-option.Mui-focused': {
      backgroundColor: 'transparent',
    },
  },
  MSDetailsPagecss: {
    '& .MuiAccordion-root:first-child': {
      marginTop: 0
    }
  },
  
  tabLabel: {
    maxWidth: "100px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    fontSize: "12px",
    textAlign: "center",
  },
  tabWithIcon: { display: "flex", flexDirection: "column", alignItems: "center" },
  dfac: { display: "flex", alignItems: "center" },
  gap6: { gap: 6 },
  gap8: { gap: 8 },
  gap10: { gap: 10 },
  gap30: { gap: 30 },
  orangeIcon: {
    color: `${colors.orange} !important`,
  },
  actionIconsRowCenter: { display: "flex", alignItems: "center", justifyContent: "center", gap: 8 },
  flexNoWrap: { flexWrap: "nowrap" },
  dfWFull: { display: "flex", width: "100%" },
  fieldInfoTooltip: { marginLeft: 4, display: "flex", cursor: "pointer" },
  mt20: { marginTop: "20px" },
  mt25: { marginTop: "25px" },
  mt14: { marginTop: "14px !important" },
  productionLineField: { marginTop: "16px", marginLeft: "16px", maxWidth: "300px" },
  mr5: { marginRight: 5 },
  ml6: { marginLeft: 6 },
  ml15: { marginLeft: 15 },
  addDocumentListbox: { "&.MuiAutocomplete-listbox": { maxHeight: 200 } },
  flexColumn: { display: "flex", flexDirection: "column" },
  m6: { margin: 6 },
  m24: { margin: 24 },
  centerContent: { justifyContent: "center", alignItems: "center" },
  uploadActionBtn: { width: 100, justifyContent: "center" },
  uploadActionBtnIcon: { fontSize: "16px !important" },
  attachIconRotate: { transform: "rotate(90deg)" },
  fontSize12Rem: { fontSize: "1.2rem" },
  flexBetweenCenter: { display: "flex", alignItems: "center", justifyContent: "space-between" },
  displayBlock: { display: "block !important" },
  justifyContentFlexStart: { justifyContent: "flex-start !important" },
  noBoxShadow: {
    boxShadow: "none !important",
    "&::before": { display: "none !important" },
    "&.ccl-form-accordion": { marginTop: "4px !important" },
    "&.ccl-form-accordion:first-child": { marginTop: "0 !important" },
    "&.ccl-form-accordion.Mui-expanded": { margin: "4px 0 !important" },
    "&.ccl-form-accordion.Mui-expanded:first-child": { marginTop: "0 !important" },
    "&.ccl-form-accordion .MuiAccordionSummary-root": { minHeight: "32px !important", padding: "0 12px !important" },
    "&.ccl-form-accordion .MuiAccordionSummary-content": { margin: "4px 0 !important" },
    "&.ccl-form-accordion .MuiAccordionDetails-root": { padding: "4px 12px 8px !important" },
  },
  P0: { padding: 0 },
  p4: { padding: 4 },
  pr8: { paddingRight: 8 },
  w25: { width: "25% !important" },
  w60: { width: "60% !important" },
  w50: { width: "50% !important" },
  w200px: { width: "200px" },
  fontWeightBold: { fontWeight: "bold" },
  flexAlignW20: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    width: "20%"
  },
  flexAlignMr15: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    marginRight: 15
  },
  textWhiteBold: {
    color: colors.white,
    fontWeight: "bold"
  },
  textWhiteNormal: {
    color: colors.white,
    fontWeight: "normal"
  },
  stickyFooter: {
    position: "sticky",
    bottom: 0,
    background: colors.white,
    zIndex: 2,
  },
  inputSmall: {fontSize: "12px"},
  tableShrink: {
    flex: 1,
    minWidth: 0,
    padding: "0 8px",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  tableDataRow: {
    backgroundColor: colors.white,
    "&:hover": {
      backgroundColor: `${colors.hoverBg} !important`,
      cursor: "pointer",
    },
  },
  authenticator: {
    width: "50px",
    height: "50px",
    fontSize: "1.5rem",
    textAlign: "center",
    margin: "5px",
  },
  dropDownCardMain: {
    marginBottom: "5px",
    border: `1px solid ${colors.borderLightest}`,
    borderRadius: "8px",
    padding: "12px",
    backgroundColor: colors.white,
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
    width: "100%",
  },
  dropDownCard: {
    marginBottom: "4px",
    fontSize: "14px",
  },
  visibleHidden: { Visibility: "hidden" },
  aligntop:{
    alignSelf: "flex-start",
    marginTop: "4px",
  },
  warningColor: {
    color: colors.warning,
  },
  errorColor: {
    color: colors.red,
  },
  prt5: {
    position: "relative",
    top: "5px",
  },
  mb15: {
    marginBottom: 15,
  },
  ml4: {
    marginLeft: 4,
  },
  cursorPointer: {
    cursor: "pointer",
  },
  flexAlignCenter: { display: "flex", alignItems: "center" },
  flexEndAlignCenter: { display: "flex", justifyContent: "flex-end", alignItems: "center" },
  overlayLoader: { zIndex: "1300 !important", color: colors.white },
  autocompletePopper: { zIndex: 1301 },
  nowrapInlineBlock: { minWidth: "120px", display: "inline-block", whiteSpace: "nowrap" },
  headerFlexWrap: { display: "inline-flex", flexWrap: "wrap", alignItems: "center" },
  tooltipIconButton: { padding: 2, marginLeft: 2 },
  inputWidth110: { width: 110 },
  underlineLink: { cursor: "pointer", textDecoration: "underline" },
  colorBlack: {
    color: colors.pureBlack,
  },
  infoLabel: {
    display: "inline-flex",
    alignItems: "center",
    position: "relative",
    top: "-2px",
    "& svg": {
      position: "relative",
    },
  },
  infoLabelView: {
    position: 'relative',
      "& svg": {
        fontSize: "18px",
        position: 'relative',
        top: '4px',
      },
  },
  infoLabelDetails: {
    position: 'relative',
    paddingLeft: '4px',
    marginBottom: '-41px',
    top: '-24px',
      "& svg": {
        fontSize: "18px",
        position: 'relative',
        top: '4px',
      },
  },  
  alignRight: {
    textAlign: "right",
  },
  alignCenter: {
    textAlign: "center",
  },
  nestedGrid: {
    backgroundColor: colors.grid,
    width: "250px",
    height: "36px",
  },
  centerAlignmentWithfullWidth: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
  },
  overflowHidden: {
    overflow: "hidden !important",
  },
  inActiveButton: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  paramButtonPosition:{
    display: "flex",
    justifyContent: "flex-end",
    marginBottom: "10px",
  },
  paramButtonPositionExtraSpace:{
    display: "flex",
    justifyContent: "flex-end",
    marginBottom: "24px",
  },
  compositionSectionTitle: {
    fontWeight: 600,
    marginBottom: 8,
  },
  fullWidthInput: {
    width: "100%",
  },
  marginRight: {
    margin: "5px",
  },
  positionRelative: {
    position: "relative",
  },
  launchpadMenuContainer: {
    alignItems: "center",
    marginTop: "10px",
  },
  launchpadMenuBox: {
    width: "95%",
    borderLeft: `2px solid ${colors.subtleBorder}`,
  },
  W5percent: {
    width: "5% !important",
  },
  basicTableNoRecords: {
    textAlign: "center",
    padding: "16px 0",
    color:colors.mutedText,
  },
  quarterFlex: {
    width: "25% !important",
    display: "flex !important",
  },

  customCheckbox: {
    color: colors.grayLight,
    '&.Mui-checked .MuiSvgIcon-root': {
      color: colors.orange,
    },
  },
  snackbarPositionCss: {
    position: "fixed",
    bottom: 20,
    left: "50%",
    transform: "translateX(-50%)",
    zIndex: 1300,
  },
  // Shared base for the Snackbar's Alert — always a white card with rounded
  // corners; only the border/text color changes per severity (below).
  snackbarAlert: {
    backgroundColor: `${colors.white} !important`,
    borderRadius: "10px !important",
    alignItems: "center !important",
  },
  snackbarAlertSuccess: {
    borderColor: `${colors.darkGreen} !important`,
    color: `${colors.darkGreen} !important`,
  },
  snackbarAlertError: {
    borderColor: `${colors.errorDark} !important`,
    color: `${colors.errorDark} !important`,
  },
  snackbarAlertWarning: {
    borderColor: `${colors.amber} !important`,
    color: `${colors.amber} !important`,
  },
  snackbarAlertInfo: {
    borderColor: `${colors.muiBlue} !important`,
    color: `${colors.muiBlue} !important`,
  },
  fullWidth: { width: "100%" },
  blackText: { color: colors.midGray },
  amberText: { color: colors.amber },
  positionRelative: { position: "relative", top: "2px" },
  verticalAlignMiddle: { verticalAlign: "middle" },
  smallInlineIcon: { fontSize: "16px !important" },
  verticalCenterFullHeight: { height: "100%", display: "flex", alignItems: "center" },
  preWrapNoScrollInput: {
    whiteSpace: "pre-wrap !important",
    wordBreak: "break-word !important",
    overflowY: "auto !important",
    resize: "none !important",
    msOverflowStyle: "none !important",
    scrollbarWidth: "none !important",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  formControls: {
    margin: theme.spacing(1),
    marginTop: theme.spacing(2),
    minWidth: "100% !important",
  },
  marginAuto: {
    margin: "auto",
  },
  centeredFlex: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
  },
  mt35: {
    marginTop: "35px !important",
  },
 
  dynamicFormFieldGrid: {
    "& > .MuiGrid-item": {
      paddingTop: "2px !important",
      paddingBottom: "2px !important",
    },
  },
  filterChip: {
    backgroundColor: `${colors.chipBg} !important`,
    color: `${colors.chipText} !important`,
    maxWidth: "280px !important",      /* prevent overflow on long filter values */
    "& .MuiChip-label": {
      overflow: "hidden !important",
      textOverflow: "ellipsis !important",
      whiteSpace: "nowrap !important",
      display: "block !important",
    },
    "& .MuiChip-deleteIcon": {
      color: `${colors.chipDeleteIcon} !important`,
      transition: "color 0.3s",
    },
    "&:hover": {
      color: `${colors.white} !important`,
      backgroundColor: `${colors.orange} !important`,
      "& .MuiChip-deleteIcon": {
        color: `${colors.white} !important`,
      },
    },
  },
  // Picked chip in FilterChip's pick-one mode: same colours as filterChip's hover.
  filterChipSelected: {
    color: `${colors.white} !important`,
    backgroundColor: `${colors.orange} !important`,
  },
  filterApplied: {
    fontWeight: "bold",
    fontSize: "1rem",
  },
  displayctrl: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    flexWrap: "wrap",
  },
  pt10: {
    paddingTop: "10px",
  },
  margins: {
    margin: "10px",
  },
  accordionTitle: {
    color: colors.orange,
  },
  prodSheduleFirstSection: {
    margin: "18px 6px",
  },
  themeColor: {
    color: colors.orange,
  },
  loaderHtrl: {
    minHeight: "150px !important",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  subTitle: {
    fontSize: fontSize.pageTitle,    // 16px — from typography tokens
    fontWeight: fontWeight.semiBold,
  },
  centerHeaderTitle: {
    textAlign: "center",
    fontWeight: "800",
  },
  innovationSpacing: {
    margin: "0 20px 10px 20px",
  },
  minW: {
    minWidth: "100%",
  },
  dFlex: {
    display: "flex",
  },
  noMarginRoundButton: {
    '& [data-testid="round-button"]': {
      margin: "0 !important",
    },
  },
  leadroot: {
    margin: 30,
    "& .MuiTextField-root": {
      margin: 10,
    },

    pomodal: {
      position: "absolute !important",
      display: "flex !important",
      flexDirection: "column !important",
      justifyContent: "center !important",
      margin: "auto !important",
      top: "50% !important",
      right: "50% !important",
      transform: "translate(50%, -50%) !important",
      width: 500,
      backgroundColor: theme.palette.background.paper,
      border: `1px solid ${colors.nearWhite} !important`,
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
    },
    modal2: {
      position: "absolute !important",
      display: "flex !important",
      flexDirection: "column !important",
      justifyContent: "center !important",
      margin: "auto !important",
      top: "50% !important",
      right: "50% !important",
      transform: "translate(50%, -50%) !important",
      width: "800px !important",
      backgroundColor: theme.palette.background.paper,
      border: `1px solid ${colors.nearWhite} !important`,
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
      overflowY: "scroll !important",
      maxHeight: "90vh !important",
      maxWidth: "90vw !important",
    },
    leadmodal: {
      position: "absolute !important",
      margin: "auto !important",
      top: "50% !important",
      left: "50% !important",
      transform: "translate(-50%, -50%) !important",
      width: "1000 !important",
      backgroundColor: `${colors.white} !important`,
      border: `2px solid ${colors.pureBlack} !important`,
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
      overflow: "scroll !important",
    },
    homeformControl: {
      margin: theme.spacing(1),
      marginTop: theme.spacing(2),
      minWidth: " 120px !important",
      // width:"40% !important",
      // marginTop:"20px !important"
    },
    homeformContro1l: {
      marginTop: "20px !important",
    },

    "& .MuiFormControl-fullWidth": {
      width: "95%",
    },
    flexGrow: 1,
    justifyContent: "center",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    "& #top-row": {
      marginTop: 10,
      marginBottom: 5,
    },
    "& .MuiGrid-item span, .MuiAccordionSummary-content .MuiGrid-root": {
      fontSize: "1.2rem !important",
    },
    "& .MuiGrid-item": {
      paddingTop: "0 !important",
    },
  },
  dNone: {
    display: "none",
  },
  alignBaseLine: {
    alignItems: "baseline !important",
  },
  dropdown1: {
    display: "flex",
    marginBottom: 5,
    gap: 20,
    alignItems: "center",
  },
  gridCategory1: {
    flex: "1.5 1.5 auto",
    minWidth: 200,
    maxWidth: 450,
  },
  gridCategory2: {
    flex: "1 1 0%",
    maxWidth: 160,
    marginLeft: 16,
  },
  dropdown: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "10px",
    gap: "20px",
    alignItems: "center",
  },
  statusGrid: {
    flex: "1 1 200px",
    maxWidth: 200,
  },
  categoryGrid: {
    flex: "1 1 160px",
    maxWidth: 160,
    marginLeft: 2,
  },
  buttonsGrid: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: 2,
  },
  grid3_sx: {
    flexGrow: 1,
  },
  mr10: {
    marginRight: "10px !important",
  },
  allStatusGrid: {
    maxWidth: 250,
  },
  createfgmodalSize: {
    width: "100% ",
    height: "100%",
    overflowY: "hidden",
  },
  modalSize: {
    width: "100% ",
    height: "100%",
    overflowY: "hidden",
  },
  modalHeader: {
    color: colors.orange,
    fontWeight: "900",
    margin: "0 0 1rem 0",
  },
  bgColorGrey: {
    backgroundColor: colors.surfaceGray,
  },
  pl10t6: {
    paddingLeft: "10px",
    paddingTop: "6px",
  },
  noteDesc: {
    paddingLeft: "10px",
    paddingTop: "6px",
    whiteSpace: "pre-wrap",
  },
  noteDescDate: {
    display: "block",
    textAlign: "right",
    fontSize: "small",
    paddingRight: "10px",
  },
  minW100: {
    minWidth: "100%",
  },
  // Action-button row wrapper (Export Excel + Create, etc.) used across
  // most grid/list pages. `gap: 10` matches the Debit Note GC reference
  // page's spacing (see `dfacjeg` below) so buttons never render flush
  // against each other.
  inlineFlex: {
    display: "inline-flex",
    gap: 10,
  },
  colWidth: {
    whiteSpace: "pre-line",
    minWidth: "110px",
    display: "inline-block",
  },
  inlineFlexWrap: {
    display: "inline-flex",
    flexWrap: "wrap",
    gap: "8px",
  },
  inlineFlexEnd: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "flex-end",
  },
  loadingOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: colors.tooltipBg,
    zIndex: 9999,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: colors.white,
    fontSize: "2rem",
    fontWeight: "bold",
    letterSpacing: "2px",
  },
  emtyText: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    color: colors.red,
    padding: "10px",
  },
  mainMultiEmail: {
    padding: "10px 4px",
    width: "48%",
    "& input": {
      padding: "5px 10px",
      width: "100%",
      height: "55px",
      border: `1px solid ${colors.inputBorder}`,
      borderRadius: "4px",
      "&:focus-visible": {
        outlineColor: `rgb(40 133 254)`,
      },
    },
    "& input::placeholder": {
      color: colors.pureBlack,
      fontSize: "15px",
    },
  },
  multiEmailTextBoxError: {
    color: colors.errorDark,
  },
  multiEmailList: {
    display: "flex",
    flexWrap: "wrap",
    gap: "5px",
    marginBottom: "8px",
    marginTop: "10px",
    "& div": {
      display: "flex",
      alignItems: "center",
      background: colors.borderLight,
      padding: "5px",
      borderRadius: "15px",
    },
    "& button": {
      marginLeft: "5px",
      cursor: "pointer",
      border: "unset",
      background: "unset",
    },
  },
  itemGroup: {
    "& .MuiTextField-root": {
      width: "100% !important",
      margin: "10px 0 !important",
    },
  },
  infoMainGrid: {
    display: "flex",
    "& .MuiInputBase-formControl": {
      marginRight: "0",
      width: "100% !important",
    },
    "& .MuiTextField-root": {
      width: "85% !important",
    },
    "& .MuiIconButton-root": {
      height: "100%",
      paddingLeft: "5px",
    },
  },
  infoMainGridAutocomplete: {
    display: "flex",
    "& .MuiFormControl-root": {
      width: "99% !important",
    },
    "& > div:first-child": {
      width: "86% !important",
    },
    "& .MuiTextField-root": {
      width: "98% !important",
    },
  },
  hsnCodeWidth: {
    width: "91% !important",
  },
  itemClassification: {
    "& .MuiTextField-root": {
      width: "100% !important",
    },
  },
  searchPipe: {
    fontSize: "28px",
    marginBottom: "0",
    position: "relative",
    top: "-2px",
  },
  autocompleteScrollListboxStyle: {
    maxHeight: "200px",
    width: "380px",
  },
  autocompleteScrollStyle: {
    width: "400px",
    position: "relative",
  },
  infinteSearchIcon: {
    position: "absolute",
    right: "50px",
    top: "25px",
    cursor: "pointer",
  },
  leadrootqli: {
    margin: 30,
    maxWidth: "100% !important",
    "& .MuiTextField-root": {
      margin: 10,
    },

    pomodal: {
      position: "absolute !important",
      display: "flex !important",
      flexDirection: "column !important",
      justifyContent: "center !important",
      margin: "auto !important",
      top: "50% !important",
      right: "50% !important",
      transform: "translate(50%, -50%) !important",
      width: 500,
      backgroundColor: theme.palette.background.paper,
      border: `1px solid ${colors.nearWhite} !important`,
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
    },

    modal2: {
      position: "absolute !important",
      display: "flex !important",
      flexDirection: "column !important",
      justifyContent: "center !important",
      margin: "auto !important",
      top: "50% !important",
      right: "50% !important",
      transform: "translate(50%, -50%) !important",
      width: "800px !important",
      backgroundColor: theme.palette.background.paper,
      border: `1px solid ${colors.nearWhite} !important`,
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
      overflowY: "scroll !important",
      maxHeight: "90vh !important",
      maxWidth: "90vw !important",
    },
    homeformControl: {
      margin: theme.spacing(1),
      marginTop: theme.spacing(2),
      minWidth: " 120px !important",
      // width:"40% !important",
      // marginTop:"20px !important"
    },
    homeformContro1l: {
      marginTop: "20px !important",
    },

    "& .MuiFormControl-fullWidth": {
      width: "95%",
    },
    flexGrow: 1,
    justifyContent: "center",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    "& #top-row": {
      marginTop: 10,
      marginBottom: 5,
    },
    "& .MuiGrid-item span, .MuiAccordionSummary-content .MuiGrid-root": {
      fontSize: "1.2rem !important",
    },
    "& .MuiGrid-item": {
      paddingTop: "0 !important",
    },
  },
  orderlineroot: {
    minWidth: "100% !important",
  },
  debitroot: {
    margin: 30,
    "& .MuiTextField-root": {
      margin: 10,
    },
    "& .MuiTextField-root": {
      marginTop: 10,
    },
    "& .MuiFormControl-fullWidth": {
      width: "95% !importnat",
    },
    "& .page-header": {
      width: "100% !importnat",
      marginBottom: 15,
    },
    "& .MuiAccordion-root": {
      width: "100% !importnat",
    },
    "& .dispatchTable": {
      maxHeight: "400px !importnat",
      overflowY: "auto !importnat",
    },
    flexGrow: 1,
    justifyContent: "center",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
  },
  csErrorMsg: {
    paddingBottom: "24px !important",
    fontSize: "16px !important",
    fontStyle: "italic !important",
    color: `${colors.red} !important`,
  },
  gcviewroot: {
    "& .MuiTextField-root": {
      marginTop: 10,
    },
    "& .MuiGrid-container": {
      alignItems: "center !important",
    },
    "& .MuiFormControl-fullWidth": {
      width: "95% !important",
    },
    "& .MuiPaper-rounded": {
      width: "100% !important",
    },
    "& .page-header": {
      width: "100% !important",
      marginBottom: 15,
    },
    "& .MuiAccordion-root": {
      width: "100% !important",
    },
    "& .dispatchTable": {
      maxHeight: "400px !important",
      overflowY: "auto !important",
    },
    flexGrow: 1,
    justifyContent: "center !important",
    display: "flex !important",
    alignItems: "center !important",
    flexDirection: "column !important",
  },
  supplierroot: {
    "& .MuiTextField-root": {
      marginTop: 10,
    },
    "& .MuiFormControl-fullWidth": {
      width: "95% !important",
    },
    flexGrow: 1,
    justifyContent: "center !important",
    display: "flex !important",
    alignItems: "center !important",
    flexDirection: "column !important",
  },
  gcroot: {
    "& .MuiTextField-root": {
      marginTop: 10,
    },
    "& .MuiFormControl-fullWidth": {
      width: "95% !important",
    },
    "& .page-header": {
      width: "100% !important",
      marginBottom: 15,
    },
    "& .MuiAccordion-root": {
      width: "100% !important",
    },
    "& .dispatchTable": {
      maxHeight: "400px !important",
      overflowY: "auto !important",
    },
    flexGrow: 1,
    justifyContent: "center !important",
    display: "flex !important",
    alignItems: "center !important",
    flexDirection: "column !important",
  },
  debitDevHeader: {
    borderBottom: `1px solid ${colors.borderLight}`,
    display: "flex",
    alignItems: "center",
  },
  debitDevDot: {
    display: "inline-block",
    width: 14,
    height: 14,
    borderRadius: 2,
    marginRight: 8,
  },
  debitQtyBg: { backgroundColor: colors.warmBg },
  debitQualBg: { backgroundColor: colors.warmBg },
  debitAmountContainer: {
    border: `1px solid ${colors.borderLight}`,
    borderRadius: 4,
    overflow: "hidden",
    width: "100%",
  },
  debitBorderRight: {
    borderRight: `1px solid ${colors.borderLight}`,
  },
  debitAmountFooter: {
  backgroundColor: colors.surfaceGray,
  borderTop: `1px solid ${colors.borderLight}`,
  display: "flex",
  justifyContent: "flex-end",
},

debitFooterContent: {
  display: "flex",
  alignItems: "center",
  gap: "28px",
},
  debitBtnRow: { margin: "4px 0" },
  debitTotalBadge: {
    borderRadius: 4,
  },
  debitLabelEnabled: { fontWeight: 600, color: colors.textEnabled },
  debitLabelDisabled: { fontWeight: 600, color: colors.textDisabledMid },
  debitTotalBox: {
    borderRadius: 4,
    backgroundColor: colors.surfaceGray,
    border: `1px solid ${colors.borderLight}`,
  },
  debitFormulaHint: { color: colors.textDisabledMid, fontWeight: 500 },
  //  loginroot: {
  //     display: 'flex !important',
  //     flexDirection: 'column !important',
  //     width: '100vw !important',
  //     position: 'relative !important',
  //     maxWidth: '100% !important',
  //     margin: 0,
  //     backgroundImage: `url(${Background}) !important`,
  //     backgroundPosition: 'center !important',
  //     backgroundSize: 'cover !important',
  //     backgroundRepeat: 'no-repeat !important',
  //     paddingRight: 0,
  //     paddingLeft: 0
  //   },
  otherModal: {
    marginTop: "8px",
    marginBottom: "8px",
    width: "100%",
  },
  mrinmodal: {
    position: "absolute !important",
    display: "flex !important",
    flexDirection: "column !important",
    justifyContent: "center !important",
    margin: "auto !important",
    top: "50% !important",
    right: "50% !important",
    transform: "translate(50%, -50%) !important",
    width: "900px !important",
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${colors.nearWhite} !important`,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    // overflowY: 'scroll',
    maxHeight: "90vh",
    maxWidth: "90vw",
  },
  createfgmodal: {
    position: "absolute !important",
    display: "flex !important",
    flexDirection: "column !important",
    justifyContent: "center !important",
    margin: "auto !important",
    top: "50% !important",
    right: "50% !important",
    transform: "translate(50%, -50%) !important",
    width: "400px !important",
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${colors.nearWhite} !important`,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    maxHeight: "90vh",
    overflow: "hidden",
    maxWidth: "90vw",
  },
  qlimodal: {
    position: "absolute",
    margin: "0 auto",
    top: "30% !important",
    right: "10% !important",
    left: "10% !important",
    width: "700px !important",
    textAlign: "left",
    backgroundColor: theme.palette.background.paper,
    border: `2px solid ${colors.pureBlack}`,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  packingmodal: {
    position: "absolute !important",
    display: "flex !important",
    flexDirection: "column !important",
    justifyContent: "center !important",
    margin: "auto !important",
    top: "50% !important",
    right: "50% !important",
    transform: "translate(50%, -50%) !important",
    width: "500px !important",
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${colors.nearWhite} !important`,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    // overflowY: 'scroll',
    maxHeight: "90vh",
    maxWidth: "90vw",
  },
  gcenquiryroot: {
    "& .MuiTextField-root": {
      marginTop: 10,
    },
    "& .MuiGrid-container": {
      alignItems: "center !important",
    },
    "& .MuiFormControl-fullWidth": {
      width: "95% !important",
    },
    "& .MuiPaper-rounded": {
      width: "100% !important",
    },
    "& .page-header": {
      width: "100% !important",
      marginBottom: 15,
    },
    "& .MuiAccordion-root": {
      width: "100% !important",
    },
    "& .dispatchTable": {
      maxHeight: "400px !important",
      overflowY: "auto !important",
    },
    flexGrow: 1,
    justifyContent: "center",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
  },
  dayContainer: {
    width: 36,
    height: 36,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxSizing: "border-box",
    padding: 0,
    margin: "0 2px",
  },
  dayCircle: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: 32,
    height: 32,
    borderRadius: "50%",
    boxSizing: "border-box",
    fontSize: 13,
    lineHeight: "13px",
  },
  cursorPointer: {
    cursor: "pointer !important",
  },
  cursorDefault: {
    cursor: "default !important",
  },
  statusToday: {
    backgroundColor: colors.lightBlue,
    color: colors.pureBlack,
  },
  statusAvailable: {
    backgroundColor: colors.green,
    color: colors.white,
  },
  statusBlocked: {
    backgroundColor: colors.red,
    color: colors.white,
  },
  statusPartial: {
    backgroundColor: colors.yellow,
    color: colors.navyDark,
  },
  statusNone: {
    backgroundColor: "transparent",
  },
  control: {
    marginTop: 3,
    marginBottom: 3,
  },
  inputDisabled: {
    pointerEvents: "none",
    backgroundColor: colors.disabledBg,
    color: colors.textDisabledMid,
    cursor: "not-allowed",
  },
  root: {
    margin: 30,
    "& .MuiTextField-root": {
      margin: 10,
    },
    "& .MuiFormControl-fullWidth": {
      width: "95%",
    },
    flexGrow: 1,
    justifyContent: "center",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    "& #top-row": {
      marginTop: 10,
      marginBottom: 5,
    },
    // "& .MuiGrid-root": {
    //     // paddingTop: '0 !important',
    //     paddingLeft: '0 !important',
    // },
    "& .MuiGrid-item": {
      paddingTop: "0 !important",
      // paddingLeft: '0 !important',
    },
  },
  orderroot: {
    minWidth: "100% !important",
  },

  orderbottom: {
    marginBottom: "20px !important",
  },
  orderformControl: {
    margin: theme.spacing(1),
    marginTop: theme.spacing(2),
    minWidth: 120,
  },

  orderbuttonSeparation: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "end",
    marginBottom: "15px",
  },
  leadviewroot: {
    marginLeft: 30,
    marginRight: 30,
    "& .MuiTextField-root": {
      marginTop: 10,
    },
    "& .MuiFormControl-fullWidth": {
      width: "95%",
    },
    flexGrow: 1,
    justifyContent: "center",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    "& #top-row": {
      marginTop: 10,
      marginBottom: 5,
    },
    "& .MuiGrid-item": {
      paddingTop: "0 !important",
      // paddingLeft: '0 !important',
    },
  },
  qliroot: {
    width: "100% !important",
    marginTop: "24 !important",
    "& .MuiBox-root":{
      top: "0 !important",
    }
  },
  qliitemroot: {
    width: "103% !important",
    marginLeft: "-24px !important",
  },
  qlirootnew: {
    width: "100% !important",
    marginTop: "24 !important",
    marginLeft: "-16px !important",
  },
  qlicontainer: {
    maxHeight: 440,
  },
  dispatchmodal: {
    position: "absolute !important",
    display: "flex !important",
    flexDirection: "column !important",
    justifyContent: "center !important",
    margin: "auto !important",
    top: "50% !important",
    right: "50% !important",
    transform: "translate(50%, -50%)",
    width: "900px !important",
    backgroundColor: theme.palette.background.paper,
    border: `2px solid ${colors.pureBlack} !important`,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  taxroot: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    display: "flex !important",
    height: "100% !important",
  },
  tabs: {
    borderRight: `1px solid ${theme.palette.divider} !important`,
    width: "100px !important",
  },
  tabList: {
    width: "15%px !important",
  },
  tabDetails: {
    width: "85% !important",
  },
  sampleviewroot: {
    marginLeft: 30,
    marginRight: 30,
    "& .MuiTextField-root": {
      marginTop: 10,
    },
    "& .MuiFormControl-fullWidth": {
      width: "75%",
    },
    flexGrow: 1,
    justifyContent: "center",
    display: "flex",
    alignItems: "center",
    paddingLeft: "0 !important",
    flexDirection: "column",
    "& #top-row": {
      marginTop: 10,
      marginBottom: 5,
    },
    "& .MuiGrid-item": {
      paddingTop: "0 !important",
      // paddingLeft: '0 !important',
    },
  },
  profileGraph: {
    marginLeft: 30,
    height: "25%",
  },
  modal1: {
    position: "absolute",
    margin: "auto",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 1000,
    backgroundColor: theme.palette.background.paper,
    border: `2px solid ${colors.pureBlack}`,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    overflow: "scroll",
  },
  changepassmodal1: {
    position: "absolute",
    margin: "auto",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "600px !important",
    backgroundColor: theme.palette.background.paper,
    border: `2px solid ${colors.pureBlack}`,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    overflow: "scroll",
  },
  poviewmodal: {
    position: "absolute !important",
    display: "flex !important",
    flexDirection: "column !important",
    justifyContent: "center !important",
    margin: "auto !important",
    top: "50% !important",
    right: "50% !important",
    transform: "translate(50%, -50%)",
    width: "1000px !important",
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${colors.nearWhite} !important`,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    overflowY: "scroll !important",
    maxHeight: "90vh !important",
    maxWidth: "90vw !important",
  },
  addContainermodal: {
    position: "absolute !important",
    display: "flex !important",
    flexDirection: "column !important",
    justifyContent: "center !important",
    margin: "auto !important",
    top: "50% !important",
    right: "50% !important",
    transform: "translate(50%, -50%)",
    width: "1000px !important",
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${colors.nearWhite} !important`,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    overflow: "hidden !important",
    maxHeight: "90vh !important",
    maxWidth: "90vw !important",
  },
  overflowAuto: {
    overflowY: "auto",
    overflowX: 'hidden !important',
  },
  ASButtonsMargin: {
    margin: "24px",
  },
  modal12: {
    position: "absolute !important",
    margin: "auto !important",
    top: "50% !important",
    left: "50% !important",
    transform: "translate(-50%, -50%)",
    width: "600px !important",
    backgroundColor: theme.palette.background.paper,
    border: `2px solid ${colors.pureBlack} !important`,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    overflow: "scroll",
  },
  // root: {
  //   "& .MuiTextField-root": {
  //     marginTop: 10,
  //   },
  //   "& .MuiFormControl-fullWidth": {
  //     width: "95%",
  //   },
  //   "& .page-header": {
  //     width: "100%",
  //     marginBottom: 15,
  //   },
  //   flexGrow: 1,
  //   justifyContent: "center",
  //   display: "flex",
  //   alignItems: "center",
  //   flexDirection: "column",
  // },
  modal3: {
    "& .MuiTextField-root": {
      marginTop: 10,
    },
    "& .MuiAutocomplete-root": {
      marginRight: 10,
    },
    position: "absolute",
    margin: "auto",
    top: "50%",
    height: "350px",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "60% !important",
    backgroundColor: useTheme().palette.background.paper,
    border: `2px solid ${colors.pureBlack}`,
    boxShadow: useTheme().shadows[5],
    padding: useTheme().spacing(2, 4, 3),
    overflow: "hidden",
  },
  modal31: {
    "& .MuiTextField-root": {
      marginTop: 10,
    },
    "& .MuiAutocomplete-root": {
      marginRight: 10,
    },
    position: "absolute",
    margin: "auto",
    top: "50%",
    height: "600px",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "90%",
    backgroundColor: theme.palette.background.paper,
    border: `2px solid ${colors.pureBlack}`,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    overflow: "hidden",
  },
  /* Blend Sheet Create/Edit page root — moved from each screen's own local
     useStyles (both files used identical styles). */
  blendSheetRoot: {
    "& .MuiTextField-root": {
      marginTop: 10,
    },
    "& .MuiFormControl-fullWidth": {
      width: "95%",
    },
    flexGrow: 1,
    justifyContent: "center",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
  },
  accountroot: {
    minWidth: "100%",
  },
  formControl: {
    margin: theme.spacing(1),
    // marginTop: theme.spacing(2),
    marginTop: "20px !important",
    marginBottom: "20px !important",
    minWidth: 120,
  },
  tableFieldMain: {
    "& .MuiTableHead-root": {
      background: colors.grid,
    },
    // Compact form inputs rendered inside table cells so rows stay the same
    // height as plain-text rows (prevents editable columns from inflating row height)
    "& .MuiInputBase-root": {
      fontSize: "var(--font-data-label, 12px)",
    },
    "& .MuiInputBase-input": {
      padding: "4px 8px !important",
      fontSize: "var(--font-data-label, 12px)",
    },
    "& .MuiFormLabel-root": {
      fontSize: "var(--font-data-label, 12px)",
      lineHeight: 1,
    },
    "& .MuiOutlinedInput-notchedOutline legend": {
      display: "none",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      top: 0,
    },
  },
  // Editable cells (file / number / date) in the dispatch document table
  documentListTable: {
    // Centre the resting label in the 44px outlined input
    "--mui-label-offset-y": "16px",
    "& .MuiTableCell-body": {
      verticalAlign: "middle",
    },
    // Let inputs grow to their content instead of the fixed 1.4375em height,
    // and use the same 14px inset as the label so text and label line up
    "& .MuiInputBase-input": {
      height: "auto",
      padding: "11px 14px !important",
    },
    // Native file input needs room for the "Choose File" button
    "& .MuiInputBase-input[type='file']": {
      padding: "8px 14px !important",
      cursor: "pointer",
    },
    // The outline notch is hidden in tables, so give the floating label a
    // background to stop the border running through it
    "& .MuiInputLabel-shrink": {
      backgroundColor: colors.white,
      padding: "0 4px",
      marginLeft: "-4px",
    },
    // DemoContainer adds top padding that pushes the date field below the others
    "& .yeardate2": {
      paddingTop: "0 !important",
      overflow: "visible !important",
    },
  },
  // BlendSheet's MRIN Details summary bar (renderMrinListTable, constant.tsx) — a standalone
  // <Table> below the main data grid, so its own borders/layout need setting independently.
  summaryBarTable: {
    "& .MuiTableCell-root": {
      borderBottom: "none",
    },
    tableLayout: "fixed",
    width: "100%",
  },
  wrapCell: {
    whiteSpace: "normal",
    wordBreak: "break-word",
  },
  nowrapCell: {
    whiteSpace: "nowrap",
  },
  PSformControl: {
    margin: theme.spacing(1),
    marginTop: "20px !important",
    marginBottom: "20px !important",
    minWidth: "100%",
    maxWidth: "100%",
  },
  selectTruncate: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "block",
    width: "100%",
  },
  ellipsisMenuItem: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "block",
    maxWidth: "100%",
  },
  truncateText: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "inline-block",
    maxWidth: "100%",
    fontSize: "1rem",
  },
  ml20: {
    marginLeft: "20px",
  },
  createPoTitle: {
    color: `${colors.orange} !important`,
    fontWeight: "700",
    alignSelf: "center",
    margin: "0 0 1rem 0",
  },
  card: {
    boxShadow:
      "0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)",
    marginBottom: 5,
  },
  modal: {
    position: "absolute !important",
    margin: "auto !important",
    top: "30% !important",
    left: "30% !important",
    width: "30% !important",
    backgroundColor: theme.palette.background.paper,
    border: `2px solid ${colors.pureBlack}`,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  modal5: {
    position: "absolute !important",
    margin: "auto !important",
    top: "30% !important",
    left: "22% !important",
    width: "59% !important",
    backgroundColor: theme.palette.background.paper,
    border: `2px solid ${colors.pureBlack}`,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  modal4: {
    "& .MuiTextField-root": {
      marginTop: 10,
    },
    "& .MuiAutocomplete-root": {
      marginRight: 10,
    },
    position: "absolute",
    margin: "auto",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: `${1000} !important`,
    height: 300,
    backgroundColor: theme.palette.background.paper,
    border: `2px solid ${colors.pureBlack}`,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    overflow: "scroll",
  },
  modalcontent: {
    // backgroundcolor: white,
    margin: 20 % "auto" /* Center modal vertically */,
    padding: 20,
    borderradius: 5,
    width: "50%" /* Default width */,
  },
  endPosition: {
    width: "100%",
    display: "flex",
    alignItems: "end",
    justifyContent: "end",
  },
  accountmodal: {
    position: "absolute",
    margin: "auto",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 1000,
    backgroundColor: theme.palette.background.paper,
    border: `2px solid ${colors.pureBlack}`,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    overflow: "scroll",
  },
  button: {
    margin: theme.spacing(1),
    backgroundColor: `${colors.orange} !important`,
    color: `${colors.white} !important`,
    // minWidth: 150,
    textTransform: "capitalize !important",
    "&:hover": {
      backgroundColor: `${colors.orange} !important`,
      opacity: 0.8,
    },
  },
  accountViewroot: {
    "& .MuiTextField-root": {
      marginTop: 10,
    },
    "& .MuiGrid-root": {
      color: colors.orange,
    },
    "& .MuiFormControl-fullWidth": {
      width: "95%",
    },
    flexGrow: 1,
    justifyContent: "center",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    "& #top-row": {
      marginTop: 10,
      marginBottom: 5,
    },
    "& .MuiGrid-item": {
      paddingTop: "0 !important",
    },
    "& .MuiAccordionSummary-root": {
      color: `${colors.orange} !important`,
    },
  },
  title: {
    flexGrow: 1,
  },
  label: {
    fontSize: theme.typography.pxToRem(20),
    fontWeight: 700,
  },
  label1: {
    fontSize: theme.typography.pxToRem(20),
    fontWeight: 700,
  },
  label2: {
    height: 60,
  },
  heading: {
    margin: "4px !important",
    fontSize: `${fontSize.sectionHeading} !important`,  // 14px — from typography tokens
    fontWeight: `${fontWeight.bold} !important`,
    color: `${colors.pureBlack} !important`,
  },
  label: {
    margin: "4px !important",
    fontSize: `${fontSize.dataLabel} !important`,        // 12px — from typography tokens
    color: `${colors.pureBlack} !important`,
  },

  // ─────────────────────────────────────────────────────────────────────────
  // TYPOGRAPHY UTILITY CLASSES  (source of truth: src/constants/typography.js)
  // Use these throughout all screens & components instead of hardcoding px values.
  // ─────────────────────────────────────────────────────────────────────────

  /** Orange section headings, e.g. "Alternative Sample Information" */
  sectionHeading: {
    color: colors.orange,
    fontSize: fontSize.sectionHeading,     // 14px
    fontWeight: fontWeight.semiBold,
    lineHeight: lineHeight.normal,
    margin: 0,
  },

  /** Muted section headings used inside accordions / sub-panels */
  subSectionHeading: {
    color: colors.pureBlack,
    fontSize: fontSize.subHeading,         // 13px
    fontWeight: fontWeight.semiBold,
    lineHeight: lineHeight.normal,
  },

  /** Field / data labels in view/detail grids (e.g. "Sample ID", "Sample Code") */
  dataLabel: {
    fontSize: fontSize.dataLabel,          // 12px
    fontWeight: fontWeight.medium,
    color: colors.textDark,
    lineHeight: lineHeight.normal,
  },

  /** Field values paired with dataLabel */
  dataValue: {
    fontSize: fontSize.dataLabel,          // 12px
    fontWeight: fontWeight.regular,
    color: colors.pureBlack,
    lineHeight: lineHeight.normal,
  },

  /** Page / screen titles rendered in the breadcrumb / AppBar area */
  pageTitle: {
    fontSize: fontSize.pageTitle,          // 16px
    fontWeight: fontWeight.semiBold,
    color: colors.orange,
    lineHeight: lineHeight.tight,
  },
  chooseBlockTypeFieldsRow: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    margin: "12px 0",
    "& .MuiFormControl-root": { minWidth: 220 },
    "& > div": { padding: "0 24px" },
    "& > div:first-child": { paddingLeft: 0 },
    "& > div:last-child": { paddingRight: 0 },
    "& > div:not(:last-child)": { borderRight: `1px solid ${colors.borderLighter}` },
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      alignItems: "stretch",
      "& .MuiFormControl-root": { minWidth: 0, width: "100%" },
      "& > div": { padding: "12px 0", width: "100%" },
      "& > div:first-child": { paddingTop: 0 },
      "& > div:last-child": { paddingBottom: 0 },
      "& > div:not(:last-child)": {
        borderRight: "none",
        borderBottom: `1px solid ${colors.borderLighter}`,
      },
    },
  },
  chooseBlockTypeRadioField: {
    flexShrink: 0,
    marginTop: 2,
  },
  chooseBlockTypeQuickApplyRadio: {
    flexShrink: 0,
    "& .MuiFormControl-root": { minWidth: 0 },
    "& .MuiFormLabel-root": {
      fontSize: "12px !important",
      color: `${colors.dimText} !important`,
      lineHeight: "inherit !important",
      display: "block",
      marginBottom: 6,
    },
  },
   chooseBlockTypeDefaultHoursSection: {
    display: "flex",
    alignItems: "center",
    flexShrink: 0,
    flexWrap: "wrap",
    marginTop: 2,
    "& > *": { padding: "0 18px" },
    "& > *:first-child": { paddingLeft: 0 },
    "& > *:last-child": { paddingRight: 0 },
    "& > *:not(:last-child)": { borderRight: `1px solid ${colors.borderLighter}` },
  },
  chooseBlockTypeDateCell: { whiteSpace: "nowrap" },
  chooseBlockTypeDateWeekday: { fontSize: 11, color: colors.subText },
  chooseBlockTypeNarrowInput: {
    width: "180px !important",
    minWidth: "180px !important",
  },
  chooseBlockTypeShiftDefaultsRow: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    alignItems: "center",
    margin: "12px 0",
    "& > div": { padding: "0 12px" },
    "& > div:first-child": { paddingLeft: 0 },
    "& > div:last-child": { paddingRight: 0 },
    "& > div:not(:last-child)": { borderRight: `1px solid ${colors.borderLighter}` },
    [theme.breakpoints.down("xs")]: {
      gridTemplateColumns: "1fr",
      "& > div": { padding: "12px 0" },
      "& > div:first-child": { paddingTop: 0 },
      "& > div:last-child": { paddingBottom: 0 },
      "& > div:not(:last-child)": {
        borderRight: "none",
        borderBottom: `1px solid ${colors.borderLighter}`,
      },
    },
  },
  chooseBlockTypeShiftHourInput: {
    flexGrow: 1,
    minWidth: 100,
  },
  chooseBlockTypeShiftGroup: {
    display: "flex",
    alignItems: "center",
    gap: 8,
  },
  chooseBlockTypeTableWrap: {
    marginTop: 8,
    overflowX: "auto",
    borderRadius: 6,
    "& .MuiTableCell-root": {
      borderRight: `1px solid ${colors.borderLight}`,
      borderBottom: `1px solid ${colors.borderLight}`,
      textAlign: "center",
    },
    "& .MuiTableCell-root:first-child": { borderLeft: `1px solid ${colors.borderLight}` },
    "& .tableFieldColumnGroupRow .MuiTableCell-root": {
      borderTop: `1px solid ${colors.borderLight}`,
      borderBottom: `1px solid ${colors.borderLight}`,
    },
    // Footer cells hold plain text (no input box), so without this they sit
    // noticeably shorter than the body rows above them.
    "& .MuiTableFooter-root .MuiTableCell-root": { padding: "15px 16px !important" },
  },
  chooseBlockTypeTableInputWrap: { display: "flex", alignItems: "center", justifyContent: "center", gap: 4 },
  chooseBlockTypeTableInput: {
    width: 50,
    "& .MuiOutlinedInput-input": { padding: "4px 6px", textAlign: "center" },
  },
  chooseBlockTypeFooterBtns: {
    display: "flex",
    justifyContent: "center",
    gap: 8,
    marginTop: 16,
  },

  chooseBlockTypeSectionCard: {
    background: colors.white,
    border: `1px solid ${colors.borderLighter}`,
    borderRadius: 8,
    padding: 16,
    marginBottom: 16,
  },
  chooseBlockTypeSectionHeaderRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: 8,
    marginBottom: 8,
  },
  chooseBlockTypeSectionHeader: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    marginBottom: 8,
  },
  chooseBlockTypeSectionIcon: { color: colors.orange, fontSize: 20 },
  chooseBlockTypeSectionTitle: { fontWeight: 700, fontSize: 15, color: colors.textDark },

  chooseBlockTypeFieldLabel: { fontSize: 12, color: colors.dimText, marginBottom: 6 },
  chooseBlockTypePillGroup: { display: "flex", gap: 10 },
  chooseBlockTypePill: {
    display: "flex",
    alignItems: "center",
    gap: 6,
    border: `1px solid ${colors.borderLight}`,
    borderRadius: 20,
    padding: "6px 14px",
    cursor: "pointer",
    fontSize: 13,
    color: colors.textMid,
    background: colors.white,
    userSelect: "none",
  },
  chooseBlockTypePillActive: {
    border: `1px solid ${colors.orange}`,
    background: colors.orangeTint,
    color: colors.orange,
    fontWeight: 600,
  },
  chooseBlockTypePillIcon: { fontSize: 16 },

  chooseBlockTypeCheckboxWithInfo: { display: "flex", alignItems: "center", gap: 2 },
  chooseBlockTypeInfoIcon: { color: colors.dimText, fontSize: 16, cursor: "help" },

  chooseBlockTypeHoursGreen: { color: colors.darkGreen, fontWeight: 600 },
  chooseBlockTypeHoursOrange: { color: colors.orange, fontWeight: 600 },
  chooseBlockTypeDeleteIcon: { color: colors.deepRed, cursor: "pointer" },
  chooseBlockTypeSummaryGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(4, 1fr)",
    gap: 12,
    marginBottom: 14,
    [theme.breakpoints.down("sm")]: { gridTemplateColumns: "repeat(2, 1fr)" },
  },
  chooseBlockTypeSummaryStat: { display: "flex", alignItems: "center", gap: 14 },
  chooseBlockTypeSummaryIconCircle: {
    width: 56,
    height: 56,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  chooseBlockTypeSummaryTextCol: { display: "flex", flexDirection: "column", gap: 4 },
  chooseBlockTypeSummaryLabel: { fontSize: 13, color: colors.dimText },
  chooseBlockTypeSummaryValue: { fontSize: 22, fontWeight: 700, color: colors.textDark },
  chooseBlockTypeInfoNote: {
    display: "flex",
    alignItems: "flex-start",
    gap: 8,
    background: colors.blueIconBg,
    border: "1px solid #BBDEFB",
    borderRadius: 6,
    padding: "10px 14px",
    fontSize: 13,
    color: colors.textDark,
  },
  chooseBlockTypeInfoNoteIcon: { color: colors.muiBlue, fontSize: 18, marginTop: 1, flexShrink: 0 },

  /** Helper / caption text below inputs or in footnotes */
  captionText: {
    fontSize: fontSize.caption,            // 11px
    fontWeight: fontWeight.regular,
    color: colors.subText,
    lineHeight: lineHeight.normal,
  },

  /** Tab label override (use on custom Tab wrappers if needed) */
  tabLabelText: {
    fontSize: fontSize.tabLabel,           // 14px
    fontWeight: fontWeight.medium,
    textTransform: "capitalize",
    lineHeight: lineHeight.normal,
  },

  /** Breadcrumb link / current segment override */
  breadcrumbText: {
    fontSize: fontSize.breadcrumb,         // 15px
    lineHeight: lineHeight.normal,
  },

  sampleroot: {
    minWidth: "100%",
  },
  mrinroot: {
    paddingTop: theme.spacing(3),
    minWidth: "100%",
  },
  createtaxroot: {
    "& .MuiTextField-root": {
      marginTop: "10px !important",
    },
    "& .MuiFormControl-fullWidth": {
      width: "95% !important",
    },
    "& .page-header": {
      width: "100% !important",
      marginBottom: "15px !important",
    },
    "& .MuiAccordion-root": {
      width: "100% !important",
    },
    "& .dispatchTable": {
      maxHeight: "400px !important",
      overflowY: "auto !important",
    },
    flexGrow: 1,
    justifyContent: "center !important",
    display: "flex !important",
    alignItems: "center !important",
    flexDirection: "column !important",
  },
  excelExport: {
    margin: "0 10px 0 0 !important",
    color: `${colors.white} !important`,

    textTransform: "capitalize !important",
    backgroundColor: `${colors.orange} !important`,
    width: "auto",
    height: "48px",
    padding: "0 20px",
    minWidth: "48px",
    minHeight: "auto",
    borderRadius: "24px !important",
    boxShadow:
      "0px 3px 5px -1px rgb(0 0 0 / 20%), 0px 6px 10px 0px rgb(0 0 0 / 14%), 0px 1px 18px 0px rgb(0 0 0 / 12%)",
  },
  userroot: {
    "& .MuiTextField-root": {
      marginTop: 10,
    },
    "& .MuiFormControl-fullWidth": {
      width: "95% !important",
    },
    flexGrow: 1,
    justifyContent: "center !important",
    display: "flex !important",
    alignItems: "center !important",
    flexDirection: "column !important",
  },
  table: {
    minWidth: "650px !important",
  },
  auditlogroot: {
    width: "100% !important",
    marginTop: "24px !important",
    textTransform: "capitalize",
  },
  container: {
    width: "95%",
  },
  container1: {
    width: "95%",
  },
  containerFull: {
    width: "100%",
  },
  customTableContainer: {
    // overflowX: "initial",
    overflow: "scroll",
    height: "450px",
  },
  borderRight: {
    borderRight: `1px solid ${colors.pureBlack}`,
  },
  approve: {
    minWidth: 150,
    margin: theme.spacing(1),
    backgroundColor: colors.approveGreen,
    color: `${colors.white} !important`,
    textTransform: "capitalize",

    "&:hover": {
      backgroundColor: colors.approveGreen,
      opacity: 0.8,
    },
  },
  reject: {
    minWidth: 150,
    margin: theme.spacing(1),
    backgroundColor: colors.rejectRed,
    color: `${colors.white} !important`,
    textTransform: "capitalize",

    "&:hover": {
      backgroundColor: colors.rejectRed,
      opacity: 0.8,
    },
  },
  alternativeroot: {
    "& .MuiTextField-root": {
      marginTop: 10,
    },
    "& .MuiGrid-root": {
      color: colors.orange,
    },
    "& .MuiFormControl-fullWidth": {
      width: "95%",
    },
    flexGrow: 1,
    justifyContent: "center",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    "& #top-row": {
      marginTop: 10,
      marginBottom: 5,
    },
  },
  loadMore: {
    cursor: "pointer",
    textAlign: "center",
    fontSize: "16px",
  },
  DropDownButton: {
    // margin: "50px 50px",
    fontSize: "1.125rem !important",
    width: "100% !important",
    height: "56px !important",
    display: "flex !important",
    alignItems: "center !important",
    justifyContent: "space-between !important",
    border: `1px solid ${colors.inputBorderAlt} !important`,
    borderRadius: "4px !important",
    backgroundColor: `${colors.white} !important`,
    cursor: "pointer !important",
    padding: "0px 20px !important",
  },
  mainDivCss: {
    position: "relative !important",
    width: "95% !important",
    border: `1px solid ${colors.inputBorderAlt}`,
    borderRadius: "4px",
  },
  mt10: {
    marginTop: "10px",
  },
  DropDownButtonLabel: {
    color: `${colors.mediumGray} !important`,
    textTransform: "capitalize !important",
    fontSize: "17px !important",
  },
  inputRoot: {
    color: "inherit !important",
    width: "100% !important",
  },
  arrowDownCss: {
    position: "absolute !important",
    right: "10px !important",
    top: "15px !important",
  },
  search: {
    position: "relative !important",
    // borderRadius: theme.shape.borderRadius,
    marginRight: 0,
    marginLeft: 0,
    width: "100% !important",
    border: "unset !important",
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: "100% !important",
    position: "absolute !important",
    pointerEvents: "none !important",
    display: "flex !important",
    alignItems: "center !important",
    justifyContent: "center !important",
  },
  searchBar: {
    width: "100% !important",
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    paddingLeft: `calc(1em + ${theme.spacing(4)}px) !important`,
    transition: theme.transitions.create("width"),
    width: "100% !important",
  },
  searchBarContainer: {
    minWidth: "inherit !important",
    display: "flex !important",
    justifyContent: "space-evenly !important",
    cursor: "default !important",
    "&.MuiListItem-button": {
      "&:hover": {
        backgroundColor: `${colors.white} !important`,
      },
    },
  },
  errorButton: {
    border: `1px solid ${colors.errorDark} !important`,
  },
  disableDropDownButton: {
    color: " rgba(0, 0, 0, 0.26) !important",
  },
  tablenodata: {
    textAlign: "center",
    padding: "18px 0 18px 0",
    "& h6": {
      color: colors.pureBlack,
      fontSize: "1rem",
    },
    "& img": {
      width: "35px",
      marginBottom: "8px",
    },
  },
  errorText: {
    color: colors.errorDark,
    fontWeight: 400,
    fontSize: "0.75rem",
    lineHeight: "1.66",
    textAlign: "left",
    marginTop: "3px",
    marginRight: "14px",
    marginBottom: "0",
    marginLeft: "14px",
  },
  DropDownButtonwidth: {
    fontSize: "1.125rem !important",
    width: "100% !important",
    height: "56px !important",
    display: "flex !important",
    alignItems: "center !important",
    justifyContent: "space-between !important",
    border: `1px solid ${colors.inputBorderAlt} !important`,
    borderRadius: "4px !important",
    backgroundColor: `${colors.white} !important`,
    cursor: "pointer !important",
    padding: "0px 20px !important",
  },
  mainDivCss: {
    position: "relative !important",
    width: "95% !important",
    borderRadius: "4px",
    marginLeft: "5px",
  },
  clearSearch: {
    cursor: "pointer",
    color: colors.orange,
  },
  DropDownButtonLabel: {
    color: colors.black,
    textTransform: "capitalize !important",
    fontSize: "1rem !important",
    fontWeight: "400",
  },
  inputRoot: {
    color: "inherit !important",
    width: "100% !important",
  },
  arrowDownCss: {
    position: "absolute !important",
    right: "10px !important",
    top: "15px !important",
  },
  disableArrowDownCss: {
    color: colors.disabledIcon,
  },
  search: {
    position: "relative !important",
    // borderRadius: theme.shape.borderRadius,
    marginRight: 0,
    marginLeft: 0,
    width: "100% !important",
    border: "unset !important",
    background: colors.white,
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: "100% !important",
    position: "absolute !important",
    pointerEvents: "none !important",
    display: "flex !important",
    alignItems: "center !important",
    justifyContent: "center !important",
  },
  searchBar: {
    width: "96% !important",
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    paddingLeft: `calc(1em + ${theme.spacing(4)}px) !important`,
    transition: theme.transitions.create("width"),
    width: "100% !important",
  },
  menuDivider: {
    margin: "0 20px !important",
  },
  dashboardSelectMenu: {
    "& .MuiPopover-paper": {
      minWidth: "380px !important",
      maxWidth: "fit-content !important",
    },
  },

  externalLinkIcon: {
    borderLeft: "1px solid var(--color-gray-eighty-five) !important",
    padding: "10px 0px 10px 10px !important",
    color: "var(--color-primary) !important",
    cursor: "pointer !important",
  },
  checkedItem: {
    color: "indigo !important",
  },
  selectContainer: {
    display: "flex !important",
    flexDirection: "row !important",
    alignItems: "center !important",
    gap: theme.spacing(1),
    padding: theme.spacing(1),
  },
  tableCell: {
    width: "50% !important",
    textAlign: "left !important",
    backgroundColor: `${colors.orange} !important`,
  },
  tableCellAllocation: {
    width: "50% !important",
    textAlign: "left !important",
    "& span": {
      display: "block",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
  },
  tableSelect: {
    "& .MuiTableCell-root": {
      border: "none !important",
      maxWidth: "400px",
    },
    "& table": {
      width: "100% !important",
      tableLayout: "fixed !important",
    },
    "& td": {
      overflow: "hidden !important",
      textOverflow: "ellipsis !important",
      whiteSpace: "nowrap !important",
    },
    "& td:first-child": {
      width: "280px !important" /* Set the first column to a fixed width */,
    },
    "& td:last-child": {
      width: "auto !important" /* Let the Remarks column expand */,
      overflow: "hidden !important",
      textOverflow: "ellipsis !important",
      whiteSpace: "nowrap !important",
    },
  },
  tableheader: {
    "& th:first-child": {
      width: "270px !important" /* Set the first column to a fixed width */,
    },
    "& th:last-child": {
      width: "auto !important" /* Let the Remarks column expand */,
      overflow: "hidden !important",
      textOverflow: "ellipsis !important",
      whiteSpace: "nowrap !important",
    },
  },
  customList: {
    width: "345px !important",
    listStyle: "none !important",
    padding: 0,
    margin: 0,
    "& li": {
      height: "50px !important",
      lineHeight: "50px !important",
      padding: "0 !important",
    },
    "& .Mui-disabled": {
      position: "sticky !important",
      top: 0,
      left: 0,
      right: 0,
      zIndex: 999,
      backgroundColor: `${colors.orange} !important !important`,
      opacity: 1,
      "& .MuiTableCell-head": {
        color: `${colors.white} !important`,
      },
    },
    "& li:nth-child(2)": {
      // marginTop: "10px",
    },
    "& .MuiPopover-paper": {
      minWidth: "432px !important",
      width: "100% !important",
      marginLeft: "3px !important",
    },
    "& .MuiMenu-list": {
      width: "670px !important",
      marginLeft: "5px !important",
    },
  },
  customSize: {
    "& .MuiPopover-paper": {
      minWidth: "480px !important",
      maxHeight: "calc(100% - 315px)",
    },
    "& .MuiMenu-list": {
      width: "100% !important",
    },
  },
  approot: {
    flexGrow: 1,
  },
  notification: {
    marginRight: "2em",
    cursor: "pointer",
    position: "relative",
  },
  notificationBox: {
    maxHeight: "355px",
    minHeight: "50px",
    minWidth: "260px",
    maxWidth: "300px",
    boxShadow: "0px 0px 4px 2px #0e0e0e38",
    padding: "10px",
  },
  loadingContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "100px",
  },
  loader: {
    color: `${colors.orange} !important`,
  },
  noNotificationContainer: {
    textAlign: "center",
    padding: "18px 0 18px 0",
    "& h6": {
      color: colors.pureBlack,
      fontSize: "1rem",
    },
  },
  noNotificationImage: {
    width: "30px",
    marginBottom: "8px",
  },
  hyperspan: {
    color: colors.hyperlink,
    cursor: "pointer",
  },
  semiNotiBox: {
    overflow: "auto",
    border: `1px solid ${colors.semiBlack}`,
    borderRadius: "10px",
    maxHeight: "275px",
    height: "auto",
    width: "100%",
  },
  mainNotiRow: {
    margin: "5px",
  },
  mainNotiRowP: {
    color: colors.pureBlack,
  },
  markRead: {
    color: colors.hyperlink,
    margin: "0 0 5px 0",
    textAlign: "right",
    cursor: "pointer",
  },
  mainNotiRowH3: {
    color: colors.pureBlack,
    margin: "0",
  },
  padding: {
    padding: theme.spacing(3),
  },
  demo2: {
    backgroundColor: `${theme.palette.background.paper} !important`,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
  label: {
    fontSize: theme.typography.pxToRem(20),
    fontWeight: 700,
  },
  label1: {
    fontSize: theme.typography.pxToRem(20),
    fontWeight: 700,
    // marginRight:300,
    // marginLeft:10,
  },
  label2: {
    height: 60,
  },
  "& .css-hip9hq-MuiPaper-root-MuiAppBar-root ": {
    color: `${colors.orange} !important`,
  },
  ml5: { marginLeft: 5 },
  filterIconBtn: {
    padding: 2,
    marginLeft: 4,
    lineHeight: 1,
  },
  headerCellContent: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    whiteSpace: "nowrap",
  },
  antPaginationWrapper: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: theme.spacing(2),
  },
  filterIconDefault: { fontSize: 11 },
  filterIconActive: { fontSize: 11, color: colors.orange },
  filterPopoverContent: { padding: 8 },
  /** Root container for FilterPopup — replaces inline style on the wrapper div. */
  filterPopupRoot: {
    padding: 8,
    width: "min(220px, calc(100vw - 40px))",
    boxSizing: "border-box",
  },
  /** Actions row inside FilterPopup — replaces inline flex styles. */
  filterActionsRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  filterInput: {
    marginBottom: 8,
    display: "block",
    width: "100% !important",         /* fill the responsive popup width */
    height: "32px !important",        /* compact input height */
    fontSize: "12px !important",
    padding: "4px 8px !important",
  },
  filterActionBtn: { fontSize: 12, padding: "0 4px" },

  /* ══════════════════════════════════════════════════════════════════════
     Auth screens (screens/Login.tsx, Authenticator/index.tsx,
     screens/ForgetPassword.tsx, components/AuthPageBackground.tsx) — shared
     split-card layout. Modifier classes (*TwostepCompact / *Forgot /
     *ForgotStep2) layer on top of a base class via className composition
     (e.g. `${classes.loginLogo} ${classes.loginLogoForgot}`); JSS inserts
     rules in the order they're defined below, so a later-defined modifier
     correctly wins the cascade over its base class when both are applied.
     ══════════════════════════════════════════════════════════════════════ */

  loginPage: {
    position: "relative",
    minHeight: "calc(100vh - 1px)",
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: colors.pageBg,
    padding: 24,
    boxSizing: "border-box",
    overflowY: "auto",
    overflowX: "hidden",
    "@media (max-height: 700px)": {
      padding: 12,
    },
    "@media (max-width: 420px)": {
      padding: 16,
    },
  },
  loginBgPattern: {
    position: "fixed",
    inset: 0,
    zIndex: 0,
    pointerEvents: "none",
    opacity: 0.1,
    mixBlendMode: "multiply",
    backgroundImage: `url(${welcomeGrainPattern})`,
    backgroundRepeat: "repeat",
    backgroundSize: "420px auto",
  },
  loginBgIllustration: {
    position: "fixed",
    top: -50,
    left: -70,
    width: 340,
    zIndex: 0,
    opacity: 0.25,
    pointerEvents: "none",
  },
  loginBgIllustrationBeans: {
    position: "fixed",
    bottom: -60,
    right: -80,
    width: 340,
    zIndex: 0,
    opacity: 0.25,
    pointerEvents: "none",
  },
  loginCard: {
    position: "relative",
    zIndex: 1,
    display: "flex",
    width: "min(90vw, 1100px)",
    minHeight: "min(88vh, 720px)",
    maxWidth: "100%",
    flexShrink: 0,
    backgroundColor: colors.white,
    borderRadius: 24,
    overflow: "hidden",
    boxShadow: "0 20px 60px rgba(0, 0, 0, 0.12)",
    "@media (max-width: 860px)": {
      width: "min(94vw, 460px)",
    },
    "@media (max-width: 420px)": {
      borderRadius: 18,
    },
  },
  loginImagePanel: {
    flex: "0 0 50%",
    // PNG is the safe default every browser understands. Browsers that
    // support image-set() (feature-detected below, not just assumed) use it
    // instead, so WebP is served where possible without breaking anywhere else.
    backgroundImage: `url(${loginBackgroundPng})`,
    "@supports (background-image: image-set(url(a) type(\"image/webp\")))": {
      backgroundImage: `image-set(url(${loginBackgroundWebp}) type("image/webp"), url(${loginBackgroundPng}) type("image/png"))`,
    },
    backgroundSize: "cover",
    backgroundPosition: "left center",
    backgroundRepeat: "no-repeat",
    "@media (max-width: 860px)": {
      display: "none",
    },
  },
  loginFormPanel: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: 32,
    boxSizing: "border-box",
    minWidth: 0,
    "@media (min-width: 861px)": {
      flex: "0 0 50%",
    },
    "@media (max-width: 420px)": {
      padding: "24px 20px",
    },
  },
  loginLogo: {
    display: "block",
    flexShrink: 0,
    width: 100,
    height: "auto",
    maxWidth: "100%",
    margin: "0 auto 4px",
    objectFit: "contain",
    "@media (max-width: 420px)": {
      width: 88,
    },
  },
  authHeading: {
    flexShrink: 0,
    margin: "0 0 4px",
    textAlign: "center",
    fontSize: 20,
    fontWeight: 700,
    color: colors.nearBlack,
  },
  loginSubtitle: {
    flexShrink: 0,
    width: "100%",
    maxWidth: 420,
    textAlign: "center",
    color: colors.textMid,
    fontSize: 15,
    fontWeight: 500,
    margin: "0 0 20px",
  },
  loginForm: {
    flexShrink: 0,
    display: "flex",
    flexDirection: "column",
    width: "100%",
    maxWidth: 420,
    "@media (min-width: 861px)": {
      maxWidth: 360,
    },
  },
  loginField: {
    marginBottom: 16,
  },
  loginLabel: {
    display: "block",
    fontSize: 13,
    fontWeight: 700,
    color: colors.nearBlack,
    marginBottom: 6,
  },
  loginInputWrap: {
    display: "flex",
    alignItems: "center",
    height: 46,
    padding: "0 14px",
    border: "1.5px solid #e5ddd8",
    borderRadius: 10,
    backgroundColor: colors.white,
    transition: "border-color 0.15s ease",
    "&:focus-within": {
      borderColor: colors.orange,
    },
    "& input": {
      flex: 1,
      height: "100%",
      minWidth: 0,
      border: "none",
      outline: "none",
      background: "transparent",
      fontFamily: "inherit",
      fontSize: 14,
      color: colors.nearBlack,
      "&::placeholder": {
        color: colors.placeholder,
      },
    },
  },
  loginInputError: {
    borderColor: colors.errorDark,
  },
  loginInputIcon: {
    flexShrink: 0,
    marginRight: 10,
    color: colors.orange,
    fontSize: "20px !important",
  },

  loginEyeBtn: {
    display: "flex",
    alignItems: "center",
    flexShrink: 0,
    marginLeft: 8,
    padding: "4px !important",
    border: "none",
    background: "none",
    color: `${colors.mutedText} !important`,
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "transparent !important",
    },
    "& svg": {
      fontSize: 20,
    },
  },
  loginErrorText: {
    display: "block",
    marginTop: 6,
    fontSize: 12,
    color: colors.errorDark,
  },
  loginHintText: {
    display: "block",
    marginTop: 6,
    fontSize: 10,
    color: colors.mutedText,
  },
  loginRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    margin: "4px 0 20px",
  },
  loginForgot: {
    fontSize: 13,
    fontWeight: 600,
    color: colors.orange,
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline",
    },
  },

  loginSubmit: {
    width: "100%",
    height: 46,
    border: "none",
    borderRadius: "10px !important",
    backgroundColor: `${colors.orange} !important`,
    color: `${colors.white} !important`,
    fontSize: 15,
    fontWeight: 700,
    letterSpacing: "0.04em",
    textTransform: "uppercase !important",
    cursor: "pointer",
    boxShadow: "0 6px 16px rgba(240, 90, 48, 0.3)",
    transition: "opacity 0.15s ease",
    "&:hover:not(:disabled)": {
      opacity: 0.92,
      backgroundColor: `${colors.orange} !important`,
    },
    "&:disabled": {
      opacity: 0.6,
      cursor: "not-allowed",
      boxShadow: "none",
    },
  },
  loginFooter: {
    flexShrink: 0,
    width: "100%",
    maxWidth: 420,
    marginTop: 16,
    textAlign: "center",
    fontSize: 13,
    color: "#444444",
  },

  /* ── Two-Step Verification modifiers (Authenticator/index.tsx) ── */
  twostepQr: {
    display: "flex",
    justifyContent: "center",
    width: "fit-content",
    margin: "0 auto 12px",
    padding: 8,
    backgroundColor: colors.white,
    border: "1.5px solid #e5ddd8",
    borderRadius: 12,
  },
  twostepOtpRow: {
    display: "flex",
    justifyContent: "center",
    gap: 10,
    marginBottom: 24,
  },
 
  twostepOtpBox: {
    width: "46px !important",
    height: "46px !important",
    padding: "0 !important",
    border: "1.5px solid #e5ddd8 !important",
    borderRadius: 10,
    fontFamily: "inherit",
    fontSize: 20,
    fontWeight: 600,
    color: colors.nearBlack,
    textAlign: "center",
    outline: "none",
    transition: "border-color 0.15s ease",
    "&:focus": {
      borderColor: `${colors.orange} !important`,
    },
  },
  loginLogoTwostepCompact: {
    width: 80,
    marginBottom: 0,
  },
  authHeadingTwostepCompact: {
    fontSize: 17,
    marginBottom: 2,
  },
  loginSubtitleTwostepCompact: {
    fontSize: 13,
    marginBottom: 10,
  },

  /* ── Forget Password modifiers (screens/ForgetPassword.tsx) ── */
  loginLogoForgot: {
    width: 84,
    marginBottom: 2,
  },
  authHeadingForgot: {
    fontSize: 18,
    marginBottom: 2,
  },
  loginSubtitleForgot: {
    fontSize: 13,
    marginBottom: 12,
  },
  loginFieldForgot: {
    marginBottom: 12,
  },
  loginLabelForgot: {
    fontSize: 12,
    marginBottom: 4,
  },
  loginInputWrapForgot: {
    height: 42,
    "& input": {
      fontSize: 13,
    },
  },
  loginSubmitForgot: {
    height: 42,
    fontSize: 14,
  },
  loginFooterForgot: {
    marginTop: 10,
    fontSize: 12,
  },
  loginLogoForgotStep2: {
    width: 72,
    marginBottom: 0,
  },
  authHeadingForgotStep2: {
    fontSize: 16,
  },
  loginSubtitleForgotStep2: {
    fontSize: 12,
    marginBottom: 8,
  },
  loginFieldForgotStep2: {
    marginBottom: 10,
  },
  loginLabelForgotStep2: {
    fontSize: 11,
    marginBottom: 3,
  },
  loginInputWrapForgotStep2: {
    height: 40,
  },
  loginSubmitForgotStep2: {
    height: 40,
  },
  loginFooterForgotStep2: {
    marginTop: 8,
  },

  /* ══════════════════════════════════════════════════════════════════════
     Home / Landing page (screens/admin/Users/Home/landing.js)
     ══════════════════════════════════════════════════════════════════════ */

  welcomeRoot: {
    position: "relative",
    flex: "1 1 auto",
    minHeight: 0,
    height: "100%",
    width: "100%",
    overflow: "hidden",
    fontFamily: "'Inter', sans-serif",
    backgroundColor: "#F5F2EE",
    color: "#211D1A",
    WebkitFontSmoothing: "antialiased",
    "&, & *, & *::before, & *::after": {
      boxSizing: "border-box",
      margin: 0,
      padding: 0,
    },
  },
  welcomeField: {
    position: "absolute",
    inset: 0,
    overflow: "hidden",
    pointerEvents: "none",
    zIndex: 0,
  },
  "@keyframes welcomeDriftA": {
    "0%, 100%": { transform: "translate(0, 0) rotate(0deg)" },
    "50%": { transform: "translate(14px, 10px) rotate(-1.5deg)" },
  },
  "@keyframes welcomeDriftB": {
    "0%, 100%": { transform: "translate(0, 0) rotate(0deg)" },
    "50%": { transform: "translate(-12px, -8px) rotate(1.2deg)" },
  },
  welcomeIllustration: {
    position: "absolute",
    opacity: 0.25,
    "@media (prefers-reduced-motion: reduce)": {
      animation: "none",
    },
  },
  welcomeIllustrationPlant: {
    top: -50,
    left: -70,
    width: 340,
    animation: "$welcomeDriftA 26s ease-in-out infinite",
  },
  welcomeIllustrationBeans: {
    bottom: -60,
    right: -80,
    width: 420,
    animation: "$welcomeDriftB 30s ease-in-out infinite",
  },
  welcomeGrain: {
    position: "absolute",
    inset: 0,
    zIndex: 1,
    pointerEvents: "none",
    opacity: 0.1,
    mixBlendMode: "multiply",
    backgroundImage: `url(${welcomeGrainPattern})`,
    backgroundRepeat: "repeat",
    backgroundSize: "420px auto",
  },
  welcomeStage: {
    position: "relative",
    zIndex: 2,
    minHeight: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: 10,
    padding: 40,
    textAlign: "center",
  },
  welcomeBrandRow: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 10,
  },
  welcomeLogo: {
    flexShrink: 0,
    width: 70,
    height: 70,
    borderRadius: 15,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 6,
    "& img": {
      width: "100%",
      height: "100%",
      display: "block",
      objectFit: "contain",
      borderRadius: 10,
    },
    "@media (max-width: 480px)": {
      width: 80,
      height: 80,
      padding: 12,
      borderRadius: 20,
    },
  },
  welcomeBrand: {
    fontSize: 20,
    fontWeight: 700,
    letterSpacing: "-0.2px",
    color: "#211D1A",
  },
  welcomeBrandSub: {
    fontSize: 14,
    fontWeight: 500,
    color: "#6E645A",
    marginTop: 2,
  },
  welcomeGreeting: {
    fontFamily: "'Inter', sans-serif",
    fontWeight: 700,
    fontSize: 44,
    letterSpacing: "-0.3px",
    color: "#211D1A",
    marginTop: 25,
    "@media (max-width: 480px)": {
      fontSize: 26,
    },
  },
  welcomeGreetingName: {
    color: "#D6531F",
  },
  welcomeNameSlot: {
    position: "relative",
    display: "inline-block",
  },
  welcomeNameGhost: {
    visibility: "hidden",
  },
  welcomeNameLive: {
    position: "absolute",
    left: 0,
    top: 0,
    whiteSpace: "nowrap",
  },
  "@keyframes welcomeRiseIn": {
    to: { opacity: 1, transform: "translateY(0)" },
  },
  welcomeSub: {
    fontSize: 20,
    color: "#6E645A",
    fontWeight: 500,
    minHeight: 22,
    opacity: 0,
    transform: "translateY(8px)",
    animation: "$welcomeRiseIn 0.6s ease forwards",
    animationDelay: "0.6s",
    "@media (prefers-reduced-motion: reduce)": {
      animation: "none !important",
      opacity: 1,
      transform: "none",
    },
  },
  "@keyframes welcomeBlink": {
    "50%": { opacity: 0 },
  },
  welcomeCursor: {
    display: "inline-block",
    marginLeft: 2,
    fontWeight: 400,
    color: "#D6531F",
    animation: "$welcomeBlink 0.85s step-end infinite",
  },
  "@keyframes welcomeCupFloat": {
    "0%, 100%": { transform: "translateY(0)" },
    "50%": { transform: "translateY(-5px)" },
  },
  welcomeCupAccent: {
    width: 56,
    marginTop: 18,
    opacity: 0,
    transform: "translateY(6px)",
    animation: "$welcomeRiseIn 0.6s ease forwards, $welcomeCupFloat 4.5s ease-in-out infinite",
    animationDelay: "0.9s, 1.3s",
    "@media (prefers-reduced-motion: reduce)": {
      animation: "none !important",
      opacity: 1,
      transform: "none",
    },
  },
  datePickerColoredDay: {
    margin: "1px 1px !important",
  },

  // ─── Panel / card layout ───────────────────────────────────────────────────
  /** Full-height flex-column container for a card/panel */
  panelFlexColumn: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  /** Bordered header bar inside a panel — label left, actions right */
  panelHeader: {
    padding: theme.spacing(1.5, 2),
    background: theme.palette.grey[50],
    borderBottom: `1px solid ${theme.palette.divider}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  /** Scrollable body area of a panel (standard height ~460px) */
  panelScrollBody: {
    flex: 1,
    overflowY: 'auto',
    maxHeight: 460,
  },
  /** Scrollable body area of a panel (compact height ~200px) */
  panelScrollBodySm: {
    flex: 1,
    overflowY: 'auto',
    maxHeight: 200,
  },

  // ─── List item interaction ─────────────────────────────────────────────────
  /** Hoverable, clickable list item with bottom divider */
  selectableListItem: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    '&:last-child': { borderBottom: 'none' },
    padding: theme.spacing(0.5, 1),
    cursor: 'pointer',
    '&:hover': { background: theme.palette.action.hover },
  },
  /** Selected state highlight for a selectable list item */
  selectedListItem: {
    background: colors.orangeOverlay8,
  },

  // ─── Empty state ──────────────────────────────────────────────────────────
  /** Centred column placeholder shown when a list/panel has no data */
  emptyStateBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(6, 2),
    color: theme.palette.text.secondary,
    textAlign: 'center',
  },

  // ─── Chip variants ────────────────────────────────────────────────────────
  /** Tiny inline category chip (height 18, fontSize 10) */
  miniChip: {
    fontSize: 10,
    height: 18,
    marginLeft: theme.spacing(0.5),
    background: theme.palette.grey[200],
    color: theme.palette.text.secondary,
  },
  /** Chip with small surrounding margin and a maximum display width */
  chipCompact: {
    margin: theme.spacing(0.25),
    maxWidth: 200,
  },

  // ─── Buttons ──────────────────────────────────────────────────────────────
  /** Very compact MUI Button for tight toolbar spaces (All / None controls) */
  compactActionButton: {
    minWidth: 0,
    padding: theme.spacing(0.25, 0.75),
    fontSize: 11,
    lineHeight: 1.4,
  },

  // ─── Typography utilities ─────────────────────────────────────────────────
  /** Small bold count label in brand colour (e.g. "15 assigned") */
  countBadgeText: {
    fontSize: 13,
    color: colors.orange,
    fontWeight: 600,
  },
  /** Muted secondary count appended to a section title */
  subtitleCount: {
    marginLeft: 6,
    fontWeight: 400,
    color: '#888',
    fontSize: 12,
  },
  /** font-weight 600 (semi-bold) */
  fontWeightSemiBold: {
    fontWeight: 600,
  },
  /** font-weight 500 (medium) */
  fontWeightMedium: {
    fontWeight: 500,
  },
  /** font-weight 400 (regular) */
  fontWeightRegular: {
    fontWeight: 400,
  },

  // ─── Spacing utilities ────────────────────────────────────────────────────
  mb16: { marginBottom: 16 },
  wFull: { width: "100%" },
  m0: { margin: 0 },
  flex1: { flex: 1 },
  flex1MinW0: { flex: 1, minWidth: 0 },
  minHeight400: { minHeight: 400 },

  // ─── Icon sizing ──────────────────────────────────────────────────────────
  /** Extra-small icon override (14 px) */
  iconXs: { fontSize: 14 },

  // PowerBI CreateEdit -- Manage User Access modal.
  powerBiManageAccessBtn: {
    whiteSpace: "nowrap",
    color: colors.orange,
    borderColor: colors.orange,
    textTransform: "none",
    fontWeight: 600,
    height: 40,
    "&:hover": { backgroundColor: colors.orange + "12", borderColor: colors.orange },
    "&:disabled": { borderColor: theme.palette.action.disabled, color: theme.palette.action.disabled },
  },
  powerBiManageAccessBtnIcon: { fontSize: 17 },
  powerBiManageAccessBtnSpinner: { color: colors.orange },
  powerBiBlockedCountChip: {
    marginLeft: 6,
    height: 18,
    fontSize: 10,
    background: colors.errorLight,
    color: colors.white,
  },
  // Modal.js's scrollableBody mode pads its body by theme.spacing(2) and scrolls that whole
  // body via `flex: 1` on an ancestor with no explicit height (Modal.js's own scrollableBodyClass) —
  // so `height: "100%"` here has nothing definite to resolve against and silently falls back to
  // plain content-driven stacking (no independent scroll region ever actually forms; this was
  // tried and doesn't work). Capping the list area's height in viewport units instead — not a
  // percentage of an indefinite ancestor — sidesteps that resolution problem entirely: the hint
  // bar and search box render at their natural size above it and never scroll, only the list does.
  // 260px estimates the rest of the modal's chrome (its own header/footer, this hint bar and
  // search box, padding) against Modal.js's own 90vh cap.
  powerBiManageAccessBody: {
    margin: theme.spacing(-2),
  },
  powerBiManageAccessListArea: {
    maxHeight: "calc(90vh - 260px)",
    overflowY: "auto",
  },
  powerBiManageAccessHintBar: {
    padding: theme.spacing(1, 2),
    background: colors.orangeTintLight,
    borderBottom: `1px solid ${colors.borderLighter}`,
  },
  powerBiManageAccessHintText: { color: colors.subText },
  // Sticks to the top of the modal's list while its role's users scroll; zIndex keeps it above the rows' toggles.
  powerBiRoleGroupHeader: {
    position: "sticky",
    top: 0,
    zIndex: 2,
    cursor: "pointer",
    userSelect: "none",
    padding: theme.spacing(0.75, 2),
    background: theme.palette.grey[100],
    borderBottom: `1px solid ${theme.palette.divider}`,
    borderTop: `1px solid ${theme.palette.divider}`,
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    color: colors.dimText,
  },
  powerBiRoleGroupLabel: {
    fontWeight: 700,
    textTransform: "uppercase",
    letterSpacing: 0.6,
    color: colors.dimText,
  },
  powerBiBlockedCountSuffix: {
    color: colors.errorLight,
    marginLeft: 6,
    fontWeight: 600,
  },
  powerBiUserSearchBox: {
    padding: theme.spacing(1.5, 2),
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  powerBiUserRow: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    padding: theme.spacing(0.75, 2),
    "&:last-child": { borderBottom: "none" },
  },
  powerBiUserRowBlocked: { background: colors.errorLight + "1a" },
  // Same flat-orange initials avatar as the sidebar's own user avatar (.appsb-user-avatar
  // in appSidebar.css), so every initials-avatar in the app reads as the same brand element.
  powerBiUserAvatar: {
    width: 34,
    height: 34,
    fontSize: 12,
    fontWeight: 700,
    background: colors.orange,
    color: colors.white,
    marginRight: theme.spacing(1.5),
    flexShrink: 0,
    // MUI's own Avatar applies a same-specificity ".MuiAvatar-colorDefault" background
    // alongside this class whenever it has no image — whichever rule lands later in the
    // compiled stylesheet wins that tie, and it isn't reliably this one. Chaining the
    // selector with MUI's own class raises specificity so this always wins.
    "&.MuiAvatar-colorDefault": {
      background: colors.orange,
    },
  },
  powerBiUserAvatarBlocked: {
    background: colors.errorLight,
    "&.MuiAvatar-colorDefault": { background: colors.errorLight },
  },
  powerBiUserNameRow: { display: "flex", alignItems: "center", gap: 6, fontSize: 14 },
  powerBiBlockIcon: { fontSize: 13, color: colors.errorLight },
  // One line, cut with "…" so a long email never runs under the row's toggle on small screens.
  powerBiUserMeta: {
    display: "block",
    fontSize: 11,
    color: theme.palette.text.secondary,
    marginTop: 1,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },

  // Role Assignments / User Access — orange checkbox/chip to match the app's brand color.
  // Checkbox defaults to color="secondary" (MUI's pink) when no color prop is given, so
  // ".MuiCheckbox-colorSecondary.Mui-checked" ties this rule's specificity — same tie as the
  // avatar's ".MuiAvatar-colorDefault" above — and can lose depending on stylesheet injection
  // order. "!important" guarantees this one always wins.
  // Full-height report page (PowerBI/ReportEmbed.tsx), laid out like the Dashboard iframe.
  powerBiEmbedRoot: { display: "flex", flexDirection: "column", flex: "1 1 auto", minHeight: 0, height: "100%", width: "100%" },
  powerBiEmbedFrameWrap: { flex: "1 1 auto", minHeight: 0, position: "relative", width: "100%" },
  powerBiEmbedFrame: { position: "absolute", top: 0, left: 0, width: "100%", height: "100%", border: "none", display: "block" },
  powerBiInlineRow: { display: "flex", alignItems: "center", gap: 8 },
  powerBiChipRow: { display: "flex", flexWrap: "wrap", gap: 8 },
  powerBiActionRow: { display: "flex", gap: 4 },
  powerBiChipList: { padding: theme.spacing(1) },
  powerBiPanelMessage: { padding: theme.spacing(3) },
  powerBiPanelMessageCompact: { padding: theme.spacing(2) },
  powerBiCheckedOrange: {
    "&.Mui-checked": { color: `${colors.orange} !important` },
  },
  // "!important" guarantees this beats MUI's own ".MuiChip-root" background/color rule —
  // both are single-class selectors, so without a color prop on Chip it's a specificity tie
  // that can lose depending on stylesheet injection order (same issue as the checkbox/avatar above).
  powerBiChipOrange: {
    backgroundColor: `${colors.orange} !important`,
    color: `${colors.white} !important`,
    "& .MuiChip-deleteIcon": {
      color: "rgba(255,255,255,0.7)",
      "&:hover": { color: colors.white },
    },
  },

  // User Report Assignment tab.
  powerBiEmptyIconMd: { fontSize: 40, opacity: 0.3, marginBottom: 8 },
  powerBiEmptyIconLg: { fontSize: 48, opacity: 0.2, marginBottom: 8 },
  powerBiEmptyPanelPaper: { height: "100%", minHeight: 400 },
  powerBiUserListRow: { display: "flex", alignItems: "center", gap: 12, padding: "6px 16px" },
  // Same flat-orange initials avatar as powerBiUserAvatar above, sized for this tab's rows.
  powerBiUserRowAvatar: {
    width: 32,
    height: 32,
    fontSize: 13,
    flexShrink: 0,
    background: colors.orange,
    color: colors.white,
    "&.MuiAvatar-colorDefault": { background: colors.orange },
  },
  powerBiUserRowAvatarBlocked: {
    background: colors.errorLight,
    "&.MuiAvatar-colorDefault": { background: colors.errorLight },
  },
  powerBiUserDetailAvatar: {
    width: 48,
    height: 48,
    fontSize: 18,
    flexShrink: 0,
    background: colors.orange,
    color: colors.white,
    "&.MuiAvatar-colorDefault": { background: colors.orange },
  },
  powerBiUserDetailHeader: {
    padding: 16,
    marginBottom: 12,
    display: "flex",
    alignItems: "flex-start",
    gap: 16,
    background: theme.palette.grey[50],
  },
  powerBiUserDetailName: { fontWeight: 600, lineHeight: 1.2 },
  powerBiBlockedBanner: {
    margin: "0 16px 12px",
    background: colors.errorLight,
    color: colors.white,
    borderRadius: 4,
    padding: "8px 16px",
    display: "flex",
    alignItems: "center",
    gap: 8,
  },
  panelHeaderBordered: { borderTop: `1px solid ${theme.palette.divider}` },
  borderLeftDivider: { borderLeft: `1px solid ${theme.palette.divider}` },
}));

export const useGlobalListStyles = makeStyles((theme) => ({
  root: {
    width: "100% !important",
    marginTop: "24px !important",
  },
  container: {
    maxHeight: "440px !important",
  },
  margin10 : {
    margin: "8px 0px 0px 0px !important",
  },
  sortHeader: {
    cursor: "pointer",
  },
  availableCapacityStyle: {
    borderLeft: `3px solid ${colors.orange}`,
    backgroundColor: colors.gridOpacity,
    padding: "10px 14px",
    borderRadius: "0 4px 4px 0",
    fontSize: "13px",
    color: colors.deepGray,
    lineHeight: 1.6,
  },
  legend_main: {
    display: "flex",
    gap: 10,
    flexWrap: "wrap",
    marginTop: 6,
    fontSize: 11,
    color: colors.dimText,
  },
  legend_item: { display: "flex", alignItems: "center", gap: 4 },
  legend_body: {
    width: 12,
    height: 12,
    borderRadius: "50%",
    display: "inline-block",
    border: "1px solid rgba(0,0,0,0.15)",
  },
  calBlockRoot: {
    padding: "0 8px",
    [theme.breakpoints.down("xs")]: { padding: "0 4px" },
  },
  calBlockSelectionHeader: { fontWeight: 600, color: colors.orange, marginBottom: 12, fontSize: 15 },
  calBlockFieldsRow: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    gap: 16,
    marginBottom: 12,
  },
  calBlockUnitLineField: {
    width: 180,
    flexShrink: 0,
    [theme.breakpoints.down("xs")]: { width: "100%" },
  },
  calBlockModeRowRight: { marginLeft: "auto" },
  calBlockStatsBar: {
    display: "grid",
    gridTemplateColumns: "repeat(6, 1fr)",
    gap: 12,
    width: "100%",
    marginBottom: 10,
    [theme.breakpoints.down("sm")]: { gridTemplateColumns: "repeat(3, 1fr)" },
    [theme.breakpoints.down("xs")]: { gridTemplateColumns: "repeat(2, 1fr)" },
  },
  calBlockStatCard: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 12,
    background: colors.white,
    border: `1px solid ${colors.borderLighter}`,
    borderRadius: 10,
    padding: "14px 16px",
    boxShadow: "0 1px 2px rgba(0,0,0,0.04)",
  },
  calBlockStatIconCircle: {
    width: 44,
    height: 44,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  calBlockStatTextCol: { display: "flex", flexDirection: "column", alignItems: "center", gap: 2, textAlign: "center" },
  calBlockStatBoxLabel: { fontSize: 11, color: colors.dimText, fontWeight: 600 },
  calBlockStatBoxValue: { fontSize: 17, fontWeight: 700, color: colors.textDark },
  calBlockLegend: {
    display: "flex",
    flexWrap: "wrap",
    gap: 12,
    padding: "10px 14px",
    borderRadius: 6,
    background: colors.surfaceLight,
    border: `1px solid ${colors.borderLighter}`,
    marginBottom: 12,
  },
  calBlockLegendItem: { display: "flex", alignItems: "center", gap: 6, fontSize: 13 },
  calBlockLegendDot: { width: 14, height: 14, borderRadius: 3, flexShrink: 0 },
  calBlockNav: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "10px 16px",
    background: colors.orangeTint,
    borderRadius: "6px 6px 0 0",
    border: `1px solid ${colors.borderLighter}`,
    borderBottom: "none",
  },
  calBlockMonthTitle: { fontWeight: 700, fontSize: 16 },
  calBlockNavBtn: {
    cursor: "pointer",
    background: "none",
    border: "none",
    padding: "4px 8px",
    borderRadius: 4,
    "&:hover": { background: colors.borderLighter },
  },
  calBlockGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(7, 1fr)",
    border: `1px solid ${colors.borderLighter}`,
    borderTop: "none",
    borderRadius: "0 0 6px 6px",
    overflow: "hidden",
  },
  calBlockDayHeader: {
    textAlign: "center",
    padding: "8px 0",
    fontSize: 12,
    fontWeight: 600,
    color: colors.textMid,
    background: colors.surfaceLight,
    borderBottom: `1px solid ${colors.borderLighter}`,
  },
  calBlockDayCell: {
    minHeight: 64,
    padding: "6px 8px",
    borderRight: `1px solid ${colors.borderLighter}`,
    borderBottom: `1px solid ${colors.borderLighter}`,
    position: "relative",
    "&:nth-child(7n)": { borderRight: "none" },
  },
  calBlockDayNumber: { fontSize: 14, fontWeight: 500 },
  calBlockDayLabel: { fontSize: 10, marginTop: 2 },
  calBlockEmptyState: {
    border: `1px dashed ${colors.borderLightest}`,
    borderRadius: 6,
    color: colors.placeholder,
  },
  calBlockConfirmPanel: {
    marginTop: 12,
    marginBottom: 16,
    border: `1.5px solid ${colors.orange}`,
    borderRadius: 6,
    padding: "14px 16px",
    background: colors.confirmBg,
  },
  calBlockConfirmTitle: { fontWeight: 600, fontSize: 14, marginBottom: 10 },
  calBlockTypeRow: {
    display: "flex",
    gap: 12,
    marginBottom: 12,
    [theme.breakpoints.down("xs")]: { flexDirection: "column" },
  },
  calBlockTypeCard: {
    flex: 1,
    border: `2px solid ${colors.borderLighter}`,
    borderRadius: 6,
    padding: "12px 16px",
    cursor: "pointer",
    textAlign: "center",
    transition: "border-color 0.2s",
    backgroundColor: colors.white,
  },
  calBlockTypeCardActive: {
    borderColor: colors.orange,
    "& $calBlockTypeTitle": { color: colors.darkRed },
    "& $calBlockTypeSubtitle": { color: colors.darkRed },
  },
  calBlockTypeTitle: { fontWeight: 600, fontSize: 13 },
  calBlockTypeSubtitle: { fontSize: 11, color: colors.subText, marginTop: 2 },
  calBlockConfirmNote: { fontSize: 12, color: colors.subText, marginBottom: 10 },
  calBlockFooterBtns: { display: "flex", gap: 10 },
  calBlockShutdownCard: { 
    background: colors.redTint,
  },
  calBlockCleaningCard: { background: colors.redTint },
  addBtnRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
  },
  addBtnNote: {
    display: "flex",
    alignItems: "center",
    gap: 6,
    color: colors.accentOrange,
    fontSize: 13,
  },
  addBtnNoteIcon: { fontSize: 18 },
  // CalendarBlocking legend
  calBlockLegendText: { color: colors.dimText, fontSize: 13, marginBottom: 12 },
  // CalendarBlocking layout + side panel
  calBlockLayout: {
    display: "flex",
    alignItems: "flex-start",
    [theme.breakpoints.down("sm")]: { flexDirection: "column" },
    "& .MuiDateCalendar-root": { maxHeight: "unset !important" }
  },
  calBlockCalendarArea: { flex: 1, minWidth: 0, width: "100%" },
  calBlockSidebarColumn: {
    display: "flex",
    flexDirection: "column",
    flexShrink: 0,
    width: 320,
    [theme.breakpoints.down("sm")]: { width: "100%" },
  },
  calBlockSidebarColumnCollapsed: {
    width: 32,
    minWidth: 32,
  },
  calBlockSidePanelRow: { position: "relative", width: "100%" },
  calBlockPanelToggleWrap: {
    position: "absolute",
    left: -26,
    top: 4,
    zIndex: 1,
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: { display: "none" },
  },
  calBlockPanelToggleBtn: {
    background: colors.surfaceGray,
    border: `1px solid ${colors.borderLight}`,
    borderRadius: 4,
    cursor: "pointer",
    padding: "6px 5px",
    minHeight: 60,
    color: colors.dimText,
    fontSize: 14,
    fontWeight: 700,
    display: "flex",
    alignItems: "center",
    "&:hover": { background: colors.borderMedium },
  },
  calBlockSidePanel: {
    width: 320,
    flexShrink: 0,
    border: `1px solid ${colors.borderLight}`,
    borderRadius: 6,
    background: colors.surfaceLight,
    padding: 14,
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      maxHeight: "none",
      marginTop: 10,
    },
  },
  calBlockPanelHeader: { fontWeight: 700, fontSize: 13, color: colors.textDark, marginBottom: 10 },
  calBlockPanelDivider: { borderTop: `1px solid ${colors.borderMedium}`, margin: "10px 0" },
  calBlockStatItem: { display: "flex", alignItems: "center", gap: 8, marginBottom: 6 },
  calBlockStatDot: { width: 10, height: 10, borderRadius: 2, flexShrink: 0 },
  calBlockStatLabel: { fontSize: 12, color: colors.dimText, flex: 1 },
  calBlockStatCount: { fontSize: 12, fontWeight: 700, color: colors.textDark },
  calBlockShiftTitle: { fontWeight: 600, fontSize: 13, color: colors.textDark, marginBottom: 8 },
  calBlockShiftDate: { fontSize: 11, color: colors.subText, marginBottom: 8 },
  calBlockShiftBlock: { marginBottom: 8 },
  calBlockShiftRow: { display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 5 },
  // Non-zero Planned/Cleaning/Shutdown hours for a shift, shown as small
  // colored chips under its row instead of always-visible zero-value fields.
  calBlockShiftBreakdownRow: { display: "flex", flexWrap: "wrap", gap: 6, marginTop: -1, marginLeft: 30 },
  calBlockShiftChip: {
    display: "inline-flex",
    alignItems: "center",
    gap: 4,
    fontSize: 11,
    color: colors.dimText,
    background: colors.surfaceGray,
    border: `1px solid ${colors.borderLight}`,
    borderRadius: 10,
    padding: "1px 8px",
  },
  calBlockShiftChipDot: { width: 6, height: 6, borderRadius: "50%", flexShrink: 0 },
  calBlockShiftLabelRow: { display: "flex", alignItems: "center", gap: 8 },
  calBlockShiftIconCircle: {
    width: 22,
    height: 22,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  calBlockShiftLabel: { fontSize: 12, color: colors.textMid },
  calBlockShiftQty: { fontSize: 12, fontWeight: 600, color: colors.textDark },
  calBlockShiftQtyHoverable: {
    cursor: "help",
    borderBottom: `1px dotted ${colors.textDark}`,
  },
  calBlockShiftTotalRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: 8,
    paddingTop: 8,
    borderTop: `1px solid ${colors.borderLight}`,
  },
  calBlockShiftTotalLabel: { fontSize: 13, fontWeight: 600, color: colors.textDark },
  calBlockShiftTotalQty: { fontSize: 13, fontWeight: 700, color: colors.darkGreen },
  calBlockPartialWarning: {
    display: "flex", alignItems: "flex-start", gap: 8,
    background: colors.warningBg, border: `1px solid ${colors.warningBorder}`, borderRadius: 6,
    padding: "8px 10px", marginBottom: 10, width: "fit-content",
    fontSize: 12, color: colors.warningDarkText, lineHeight: 1.4,
  },
  calBlockPartialWarningIcon: { fontSize: 18, flexShrink: 0, marginTop: -1 },
  // MonthCalendarView day cells
  calDayCell: {
    position: "relative",
    width: "100%",
    minHeight: 52,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    userSelect: "none",
    gap: 1,
    borderRight: `1px solid ${colors.borderLight}`,
    borderBottom: `1px solid ${colors.borderLight}`,
  },
  calDayCellExpanded: { minHeight: 84, padding: 0 },
  calDaySelectedCell: {
    backgroundColor: colors.calSelectedDay,
    cursor: "pointer",
  },
  calDayCheckmark: {
    position: "absolute",
    top: 2,
    right: 4,
    fontSize: 11,
    fontWeight: 700,
    color: colors.calSelectedText,
    lineHeight: 1,
  },
  calDayNum: { fontSize: 18, fontWeight: 700, lineHeight: 1 },
  calDayNumSelected: { color: colors.calSelectedText },
  calDayLabel: { fontSize: 10, fontWeight: 500 },
  calDayLabelSelected: { color: colors.calSelectedText, fontWeight: 600 },
  calDayInfoLine: { fontSize: 9, fontWeight: 600, lineHeight: 1.15 },
  calDayTooltipWrapper: { width: "100%", height: "100%" },
  calDayPast: { opacity: 0.5 },
  calDayClickable: { cursor: "pointer" },
  calDayNotClickable: { cursor: "default" },
  calDayToday: { cursor: "not-allowed" },
  calDayTodayBadge: {
    position: "absolute",
    top: 4,
    right: 6,
    fontSize: 8,
    fontWeight: 700,
    color: colors.white,
    background: "rgba(0,0,0,0.28)",
    borderRadius: 4,
    padding: "1px 5px",
    letterSpacing: 0.3,
    textTransform: "uppercase",
    lineHeight: 1.4,
  },
  // CalendarBlocking — multi-select mode
  calBlockModeRow: {
    display: "flex",
    alignItems: "center",
    flexShrink: 0,
    gap: 10,
  },
  calBlockModeLabel: { fontSize: 13, fontWeight: 600, color: colors.textDark, whiteSpace: "nowrap" },
  calBlockToggleTrack: {
    width: 36,
    height: 20,
    borderRadius: 10,
    background: colors.borderMedium,
    border: "none",
    padding: 0,
    position: "relative",
    cursor: "pointer",
    flexShrink: 0,
    transition: "background 0.2s ease",
    "&:disabled": { cursor: "not-allowed", opacity: 0.5 },
  },
  calBlockToggleTrackOn: { background: colors.orange },
  calBlockToggleThumb: {
    position: "absolute",
    top: 2,
    left: 2,
    width: 16,
    height: 16,
    borderRadius: "50%",
    background: colors.white,
    boxShadow: "0 1px 2px rgba(0,0,0,0.3)",
    transition: "left 0.2s ease",
  },
  calBlockToggleThumbOn: { left: 18 },
  calDayMultiSelectedCell: {
    boxShadow: `inset 0 0 0 2px ${colors.orange}`,
    background: colors.orangeTint,
    cursor: "pointer",
  },
  calDayMultiBadge: {
    position: "absolute",
    top: 2,
    right: 2,
    width: 18,
    height: 18,
    borderRadius: "50%",
    background: colors.orange,
    color: colors.white,
    fontSize: 11,
    fontWeight: 700,
    lineHeight: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  calBlockSelectedHeaderRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 10,
  },
  calBlockSelectedCountChip: {
    background: colors.orangeTint,
    color: colors.orange,
    fontSize: 11,
    fontWeight: 700,
    borderRadius: 12,
    padding: "2px 8px",
  },
  calBlockSelectedList: {
    display: "flex",
    flexDirection: "column",
    gap: 8,
    marginBottom: 10,
    maxHeight: 260,
    overflowY: "auto",
  },
  calBlockSelectedChip: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 8,
    background: colors.orangeTint,
    border: `1px solid ${colors.orangeTintDark}`,
    borderRadius: 8,
    padding: "8px 10px",
  },
  calBlockSelectedChipDate: { color: colors.orange, fontWeight: 600, fontSize: 13 },
  calBlockSelectedChipRemove: {
    background: colors.white,
    border: `1px solid ${colors.borderMedium}`,
    borderRadius: 6,
    width: 24,
    height: 24,
    flexShrink: 0,
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 14,
    color: colors.textMid,
    "&:hover": { background: colors.borderLight },
  },
  calBlockClearAllBtn: {
    background: "none",
    border: "none",
    color: colors.darkRed,
    fontSize: 12,
    fontWeight: 600,
    cursor: "pointer",
    padding: 0,
    marginBottom: 4,
    "&:hover": { textDecoration: "underline" },
  },
  calBlockSelectedSummaryLabel: { fontSize: 12, color: colors.dimText, marginBottom: 4 },
  calBlockSelectedSummaryTotal: { fontSize: 15, fontWeight: 700, color: colors.darkGreen, marginBottom: 2 },
  calBlockNextBtnWrap: { marginTop: 14 },
}));

export const dateCalendarSx = {
  width: "100%",
  maxWidth: "100%",
  height: "auto",
  overflow: "visible",
  "& .MuiDayCalendar-root": { height: "auto !important" },
  "& .MuiDayCalendar-slideTransition": {
    overflow: "visible",
    minHeight: "unset !important",
    height: "auto !important",
  },
  "& .MuiDayCalendar-monthContainer": {
    overflow: "visible",
    position: "static",
    height: "auto !important",
  },
  "& .MuiPickersCalendarHeader-root": {
    backgroundColor: colors.calHeaderBg,
    borderRadius: "6px 6px 0 0",
    margin: 0,
    paddingLeft: "17px",
    paddingRight: "34px",
  },
  "& .MuiDayCalendar-header": {
    display: "grid",
    gridTemplateColumns: "repeat(7, 1fr)",
    width: "100%",
    boxSizing: "border-box",
    borderLeft: `1px solid ${colors.borderLight}`,
    borderTop: `1px solid ${colors.borderLight}`,
  },
  "& .MuiDayCalendar-weekContainer": {
    display: "grid",
    gridTemplateColumns: "repeat(7, 1fr)",
    width: "100%",
    margin: 0,
    gap: 0,
    borderLeft: `1px solid ${colors.borderLight}`,
  },
  "& .MuiDayCalendar-weekDayLabel": {
    textAlign: "center",
    width: "100%",
    height: "40px",
    borderRight: `1px solid ${colors.borderLight}`,
    borderBottom: `1px solid ${colors.borderLight}`,
    fontWeight: 600,
    color: colors.dimText,
    margin: 0,
    whiteSpace: "nowrap",
  },
  "& .MuiPickersDay-root": {
    width: "100%",
    borderRadius: 0,
    margin: 0,
    height: "52px",
    borderRight: `1px solid ${colors.borderLight}`,
    borderBottom: `1px solid ${colors.borderLight}`,
  },
};

export const useStyledTableRow = withStyles({
  root: {
    "&:nth-of-type(even)": {
      //   backgroundColor: theme.palette.action.hover,
    },
    "MuiTableCell-head": {
      backgroundColor: `${colors.grid} !important`,
    },
    "& .MuiOutlinedInput-input": {
      padding: "10px 14px",
    },
  },
});

export const useStyledTableCell = makeStyles({
  head: {
    backgroundColor: `${colors.grid} !important`,
    // color: 'black'
  },
  body: {
    fontSize: 14,
  },
  "MuiTableCell-head": {
    backgroundColor: `${colors.grid} !important`,
  },
});
export const useStyledMenuItem = makeStyles({
  root: {
    "&:focus": {
      backgroundColor: colors.orange,
      // '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
      //   color: theme.palette.common.white,
      // },
    },
  },
});

export const useGlobalTabs = makeStyles({
  root: {
    flexGrow: 1,
  },
  tabs: {
    "& .MuiTab-root": {
      color: `${colors.orange} !important`,
      textTransform: "capitalize",
      fontSize: "18px",
    },
    "& .MuiTabs-indicator": {
      backgroundColor: `${colors.orange} !important`,
    },
  },
});

export const useGlobalStepper = makeStyles((theme) => ({
  // export const useGlobalStepper = () => {
  //   const theme = useTheme();
  //   return makeStyles({
  root: {
    width: "100%",
    "& .MuiStep-horizontal": {
      padding: 0,
    },
    "& .MuiStepConnector-root": {
      display: "none",
    },
    "& .MuiStep-root": {
      flex: "1 1 0%",
      pointer: "cursor",
      marginLeft: ".375rem",
      marginRight: ".4375rem",
      background: "var(--lwc-colorBackgroundPathIncomplete,rgb(236, 235, 234))",
      " & .MuiStepLabel-label": {
        color: colors.pureBlack,
        padding: "0.65rem",
        width: "max-content",
      },
    },
    " & .Mui-completed": {
      background:
        "var(--lwc-colorBackgroundPathComplete,rgb(69, 198, 90)) !important",
      " & .MuiStepLabel-label": {
        color: `${colors.white} !important`,
        borderTopLeftRadius: "var(--lwc-heightSalesPath, 2rem)",
        borderBottomLeftRadius: "var(--lwc-heightSalesPath, 2rem)",
      },
    },
    " & .MuiStep-root div.active": {
      background: "var(--lwc-colorBackgroundPathActive,rgb(1, 68, 134))",
      " & .MuiStepLabel-label": {
        color: `${colors.white} !important`,
        padding: "0.65rem",
      },
    },
    " & .MuiStep-root div.reject": {
      background: "var(--lwc-colorBackgroundPathActive,rgb(245, 15, 15))",
      " & .MuiStepLabel-label": {
        color: `${colors.white} !important`,
        padding: "0.65rem",
      },
    },
    " & .MuiPaper-root .MuiStep-root:first-child, & .MuiPaper-root .MuiStep-root:first-child > div":
      {
        borderTopLeftRadius: "var(--lwc-heightSalesPath,2rem)",
        borderBottomLeftRadius: "var(--lwc-heightSalesPath,2rem)",
      },
    " & .MuiPaper-root .MuiStep-root:last-child, & .MuiPaper-root .MuiStep-root:last-child > div":
      {
        marginRight: 0,
        borderTopRightRadius: "var(--lwc-heightSalesPath,2rem)",
        borderBottomRightRadius: "var(--lwc-heightSalesPath,2rem)",
        paddingRight: ".625rem",
      },
    "& .MuiStepLabel-iconContainer": {
      isplay: "none",
    },
  },
  disabledStep: {
    background:
      "var(--lwc-colorBackgroundPathIncomplete,rgb(236, 235, 234)) !important",
  },
  button: {
    marginRight: theme.spacing(1),
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
}));

export const useOrderStepper = makeStyles((theme) => ({
  root: {
    width: "100%",
    "& .MuiStep-horizontal": {
      padding: 0,
    },
    "& .MuiStepConnector-root": {
      display: "none",
    },
    "& .MuiStep-root": {
      flex: "1 1 0%",
      pointer: "cursor",
      marginLeft: ".375rem",
      marginRight: ".4375rem",
      background: "var(--lwc-colorBackgroundPathIncomplete,rgb(236, 235, 234))",
      " & .MuiStepLabel-label": {
        color: colors.pureBlack,
        padding: "0.65rem",
        width: "max-content",
      },
    },
    " & .MuiStep-completed": {
      background: "var(--lwc-colorBackgroundPathComplete,rgb(69, 198, 90))",
      " & .MuiStepLabel-label": {
        color: `${colors.white} !important`,
        padding: "0.75rem",
      },
    },
    " & .MuiStep-root div.active": {
      background: "var(--lwc-colorBackgroundPathActive,rgb(1, 68, 134))",
      " & .MuiStepLabel-label": {
        color: `${colors.white} !important`,
        padding: "0.65rem",
      },
    },
    " & .MuiStep-root div.reject": {
      background: "var(--lwc-colorBackgroundPathActive,rgb(245, 15, 15))",
      " & .MuiStepLabel-label": {
        color: `${colors.white} !important`,
        padding: "0.65rem",
      },
    },
    " & .MuiPaper-root .MuiStep-root:first-child, & .MuiPaper-root .MuiStep-root:first-child > div":
      {
        borderTopLeftRadius: "var(--lwc-heightSalesPath,2rem)",
        borderBottomLeftRadius: "var(--lwc-heightSalesPath,2rem)",
      },
    " & .MuiPaper-root .MuiStep-root:last-child, & .MuiPaper-root .MuiStep-root:last-child > div":
      {
        marginRight: 0,

        borderTopRightRadius: "var(--lwc-heightSalesPath,2rem)",
        borderBottomRightRadius: "var(--lwc-heightSalesPath,2rem)",
      },
  },
  test: {
    backgroundColor: colors.red,
  },
  disabledStep: {
    background:
      "var(--lwc-colorBackgroundPathIncomplete,rgb(236, 235, 234)) !important",
  },
  button: {
    marginRight: theme.spacing(1),
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
}));

export const useQuotationStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      marginTop: 10,
    },
    "& .MuiFormControl-fullWidth": {
      width: "95%",
    },
    "& .page-header": {
      width: "100%",
      marginBottom: 15,
    },
    flexGrow: 1,
    justifyContent: "center",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
  },
  card: {
    boxShadow:
      "0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)",
    marginBottom: 5,
  },
  modal: {
    position: "absolute !important",
    margin: "auto !important",
    top: "30% !important",
    left: "30% !important",
    width: "30% !important",
    backgroundColor: theme.palette.background.paper,
    border: `2px solid ${colors.pureBlack} !important`,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  endPosition: {
    width: "100% !important",
    display: "flex !important",
    alignItems: "end !important",
    justifyContent: "end !important",
    textAlign: "end !important",
  },
  button: {
    margin: theme.spacing(1),
    backgroundColor: `${colors.orange} !important`,
    color: `${colors.white} !important`,
    minWidth: "50px !important",
    textTransform: "capitalize !important",

    "&:hover": {
      backgroundColor: `${colors.orange} !important`,
      opacity: 0.8,
    },
    "& $MuiButton-label": {
      margin: 0,
    },
  },
  approveclass: {
    marginTop: "160px !important",
  },
  popover: {
    padding: theme.spacing(2, 4, 3),
  },
  links: {
    marginTop: 10,
    cursor: "pointer",
  },
}));

export const useAlternativeSampleStyles = makeStyles({
  tableHead: {
    backgroundColor: `${colors.white} !important`,
  },
  errorText: { color: colors.red, marginTop: "5px", fontSize: "12px" },
});

const useMultiColumnStyles = makeStyles((theme) => ({
  multiColPopperMain: {
    backgroundColor: colors.white,
    // Header and option rows share equal columns that always fit the popper
    // (configured column widths can add up to more than 100%)
    "& $multiColPopper, & .MuiAutocomplete-option > div": {
      gridTemplateColumns: "none !important",
      gridAutoFlow: "column",
      gridAutoColumns: "minmax(0, 1fr)",
    },
    "& $multiColPopper > span": {
      minWidth: 0,
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
    "& .MuiAutocomplete-option > div > span": {
      minWidth: 0,
      whiteSpace: "normal",
      wordBreak: "break-word",
    },
    // Reserve the scrollbar space on both header and list so columns line up
    "& $multiColPopper, & .MuiAutocomplete-listbox": {
      scrollbarGutter: "stable",
    },
  },
  multiColPopper: {
    display: "grid",
    columnGap: "8px",
    fontWeight: "bold",
    padding: "8px 16px",
    overflow: "hidden",
    borderBottom: `1px solid ${colors.borderLightest}`,
    background: colors.grid,
  },
  // Opt-in — centers header + option text. Applied alongside multiColPopperMain
  // only by callers that explicitly ask for it (e.g. Production Schedule),
  // so every other MultiColumnAsyncAutocomplete/AsyncTableSearchSelect popper
  // keeps its default left alignment.
  multiColPopperCentered: {
    "& $multiColPopper > span, & .MuiAutocomplete-option > div > span": {
      textAlign: "center",
    },
  },
}));

export const useMultiColumnGlobalStyles = () => {
  const theme = useTheme();
  return useMultiColumnStyles(theme);
};

export const useStatusStepperStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    borderRadius: 2,
    margin: "20px 0",
    overflow: "hidden", 
  },
  stackContent: {
    padding: "10px 0",
    "&:last-child": {
      paddingBottom: "19px !important",
    },
  },
  firstBox: {
    borderRadius: "20px 0 0 20px",
    marginLeft: '16px' 
  },
  lastBox: {
    borderRadius: "0 20px 20px 0",
    marginRight: '16px'
  },
  customColorBox: {
    backgroundColor: theme.palette.grey[300],
  },
  scrollContainer: {
    display: "flex",
    width: "100%",
    overflowX: "auto",
    // Scrollbar styling
    "&::-webkit-scrollbar": { height: "8px" },
    "&::-webkit-scrollbar-track": { backgroundColor: colors.scrollbarTrack, borderRadius: "10px" },
    "&::-webkit-scrollbar-thumb": { backgroundColor: colors.subText, borderRadius: "10px" },
    "&::-webkit-scrollbar-thumb:hover": { backgroundColor: colors.dimText },
  },
  stackBox: {
    padding: "10px 16px",
    flex: 1,
    minWidth: "120px",
    textAlign: "center",
    cursor: "default",
    transition: "background-color 0.3s ease",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    whiteSpace: "normal",
    wordBreak: "break-word",
  },
  doubleBox: {
    whiteSpace: 'nowrap',
    overflow: 'visible',
    fontSize: '16px',
    padding: "10px 12px",
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minheight: '100%',
    minWidth: '260px', 
    flexGrow: 2, 
  },
  stackDivider: {
    backgroundColor: colors.nearBlack,
    width: "1px",
    flexShrink: 0, 
  },
  incomplete: {
    backgroundColor: colors.borderLight,
    '& .status_text': {
      color: colors.pureBlack
    }
  },
    completed: {
    backgroundColor: colors.completedGreen,
    '& .status_text': {
      color: colors.white,
    }
  },
  approved: {
    backgroundColor: colors.completedGreen,
    '& .status_text': {
      color: colors.white,
    }
  },
  inprogress: {
    backgroundColor: colors.inProgressYellow,
    '& .status_text': {
      color: colors.black,
    }
  },
  rejected: {
    backgroundColor: colors.red,
    '& .status_text': {
      color: colors.white,
    }
  },
  // FilterPopup layout -- replaces inline style props on the FilterPopup component.
  filterPopupRoot: { padding: "8px 0", width: 220, boxSizing: "border-box" },
  filterActionsRow: { display: "flex", justifyContent: "space-between", alignItems: "center" },

}))

